import {Injectable} from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {Observable, of} from "rxjs";
import {
  emptyWorkflowAction,
  emptyWorkflowArticleCreationReportItem,
  emptyWorkflowArticleItem,
  emptyWorkflowAuthData,
  emptyWorkflowBonusTaskItem,
  emptyWorkflowFile,
  emptyWorkflowFileInfo,
  emptyWorkflowForm,
  emptyWorkflowGroup,
  emptyWorkflowHeadArticles,
  emptyWorkflowIrTask,
  emptyWorkflowNomenclatureItem,
  emptyWorkflowProcess,
  emptyWorkflowProcessStage,
  emptyWorkflowProcessType,
  emptyWorkflowTariffFile,
  emptyWorkflowTariffItem,
  emptyWorkflowTariffLoadReportItem,
  emptyWorkflowTask,
  emptyWorkflowTaskAssignmentItem,
  emptyWorkflowEventTypeItem,
  emptyWorkflowEvent,
  IWorkflowAction,
  IWorkflowArticleCreationReportItem,
  IWorkflowArticleItem,
  IWorkflowAuthData,
  IWorkflowBonusTaskItem,
  IWorkflowFile,
  IWorkflowFileInfo,
  IWorkflowForm,
  IWorkflowGroup,
  IWorkflowHeadArticles,
  IWorkflowIrTask,
  IWorkflowNomenclatureItem,
  IWorkflowProcess,
  IWorkflowProcessStage,
  IWorkflowProcessType,
  IWorkflowTariffCompareReportItem,
  IWorkflowTariffFile,
  IWorkflowTariffItem,
  IWorkflowTariffLoadReportItem,
  IWorkflowTask,
  IWorkflowTaskAssignmentItem,
  IWorkflowEventTypeItem,
  IWorkflowEvent,
  IWorkflowCloseHeadArticles,
  emptyWorkflowCloseHeadArticles,
  IWorkflowCloseArticle,
  emptyWorkflowCloseArticle,
  IWorkflowCloseReasons,
  emptyWorkflowCloseReasons,
  IWorkflowCloseGrappaItem,
  emptyWorkflowCloseGrappaItem,
  IWorkflowReactivateHeadArticles,
  emptyWorkflowReactivateHeadArticles,
  IWorkflowPricelistArticle,
  emptyWorkflowPricelistArticle,
  IWorkflowAnalyticsArticleItem,
  emptyWorkflowAnalyticsArticleItem,
  IWorkflowArticleCloseReportItem,
  emptyWorkflowArticleCloseReportItem,
  IWorkflowArticleModifyReportItem,
  emptyWorkflowArticleModifyReportItem,
  IWorkflowWarrantyLettersReportItem,
  emptyWorkflowWarrantyLettersReportItem,
  IWorkflowPricelistsReportItem,
  emptyWorkflowPricelistsReportItem,
  IWorkflowShelfLifeReportItem,
  emptyWorkflowShelfLifeReportItem,
  IWorkflowAnalyticsInflArticleItem,
  emptyWorkflowAnalyticsInflArticleItem,
  IWorkflowAnalyticsInflCommonItem,
  emptyWorkflowAnalyticsInflCommonItem,
  emptyWorkflowAnalyticsInflFamilyItem,
  IWorkflowAnalyticsInflFamilyItem,
  IWorkflowAnalyticsHistoryTariffGridItem,
  emptyWorkflowAnalyticsHistoryTariffGridItem,
  IWorkflowAnalyticsHistoryTariffChartItem,
  emptyWorkflowAnalyticsHistoryTariffChartItem,
  IWorkflowAnalyticsHistoryTariffArticleItem,
  IWorkflowAnalyticsHistoryTariffArticleHistoryItem,
  emptyWorkflowAnalyticsHistoryTariffArticleItem, emptyWorkflowAnalyticsHistoryTariffArticleHistoryItem,
  IWorkflowUserItem, emptyWorkflowUserItem, IWorkflowUserDepartmentItem, emptyWorkflowUserDepartmentItem, IPeriodListItem, emptyPeriodListItem, IUserSubstitutionItem, emptyUserSubstitutionItem, INomenclatureTreeItem, emptyNomenclatureTreeItem
} from "@retail-data-factory/rdf-angular-types-api";
import {ApiService} from "../../../../services/external-api/api.service";
import {catchError, map, mergeMap} from "rxjs/operators";
import * as moment from 'moment';
import {MockWorkflowFile, MockWorkflowFiles} from "./mock-workflow";
import {emptyServiceResponse, IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {emptySite, ISite} from "@retail-data-factory/rdf-angular-types-api";
//import {MockService} from "../../../../services/mock/mock.service";
import {Presenter} from "../../../internal/presenter/presenter";
import {wfEcrGroups, wfEcrGroupsRd} from "./mock-data/groups-ecr";
import {taskSites_ecr_rd} from "./mock-data/sites-ecr";
import {
  mapAuchanAuditProcessesFromService,
  mapAuchanTaskFromService
} from "./mapping-functions/mapping-auchan";
import {mapProcessFromService, mapProcessTypeFromService, mapTaskFromService} from "./mapping-functions/mapping-rdf";
import {EButtonType} from "@retail-data-factory/rdf-angular-components";
import {emptyTranslatedName} from "@retail-data-factory/rdf-angular-translation-service";
import {IListItem} from "@retail-data-factory/rdf-angular-types-components";
import {emptyWorkflowArticleStrItem, IWorkflowArticleStrItem} from "@retail-data-factory/rdf-angular-types-api";

@Injectable({
  providedIn: 'root'
})
export class ApiWorkflowService {

  articleList: Array<IWorkflowArticleStrItem> = [];

  constructor(
    private dataService: DataService,
    private apiService: ApiService,
    private presenter: Presenter,
    private configurationManager: ConfigurationManager,
    //private mockService: MockService
  ) {
  }

  isLikeAuchanMode() {
    return (this.configurationManager.theme === 'auchan' || this.configurationManager.theme === 'portal');
  }

  getProcessTypes():Observable<Array<IWorkflowProcessType>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions`, param).pipe(
      map(result => {
        console.log(result);
        const processTypes: Array<IWorkflowProcessType> = result.report.map(t => mapProcessTypeFromService(t));
        return processTypes;
      })
    );
  }

  getProcessType(processTypeId: string):Observable<IWorkflowProcessType>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}`, param).pipe(
      map(result => {
        return result.report.length? mapProcessTypeFromService(result.report[0]):{...emptyWorkflowProcessType};
      })
    );
  }

  createProcessType(processTypeId: string):Observable<IWorkflowProcessType>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}`, param).pipe(
      map(result => {
        return result.report.length? mapProcessTypeFromService(result.report[0]):{...emptyWorkflowProcessType};
      })
    );
  }



  getProcessTypeForms(processTypeId: string): Observable<Array<IWorkflowForm>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}/forms`, param).pipe(
      map(result => {
        return result.report.map(item=>this.mapFormFromService(item));
      })
    );

  }
  getProcessTypeActions(processTypeId: string): Observable<Array<IWorkflowAction>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}/actions`, param).pipe(
      map(result => {
        return result.report.map(item=>this.mapActionFromService(item));
      })
    );

  }
  getProcessTypeStages(processTypeId: string): Observable<Array<IWorkflowProcessStage>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}/stages`, param).pipe(
      map(result => {
        return result.report.map(item=>this.mapStageFromService(item));
      })
    );

  }

  getProcessStage(processStageId: string): Observable<IWorkflowProcessStage>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/stages/${processStageId}`, param).pipe(
      map(result => {
        if (result.report.length) {
          return this.mapStageFromService(result.report[0]);
        } else {
          return {...emptyWorkflowProcessStage};
        }
      })
    );
  }


  getProcessStageForms(processStageId: string): Observable<Array<IWorkflowForm>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/stages/${processStageId}/forms`, param).pipe(
      map(result => {
        return result.report.map(item=>this.mapFormFromService(item));
      })
    );

  }
  getProcessStageActions(processStageId: string): Observable<Array<IWorkflowAction>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/stages/${processStageId}/actions`, param).pipe(
      map(result => {
        return result.report.map(item=>this.mapActionFromService(item));
      })
    );

  }


  authenticate(login: string, password: string, accessToken: string): Observable<IWorkflowAuthData> {
    const header = login && password?
      {
        login: login,
        password: password,
        access_token: accessToken
      }:
      {
        access_token: accessToken
      }
    ;
    return this.apiService.get(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/authenticate`, header).pipe(
      map(result => {
        if (result && result['profile'] && result['profile']['sso_token']) {
          const authData: IWorkflowAuthData = {
            userName: result['profile']['Commonname'],
            userId: result['profile']['Uid'],
            email: result['profile']['Email'],
            ssoToken: result['profile']['sso_token']
          };
          return authData;
        }
        return {...emptyWorkflowAuthData};
      })
    );
  }

  getProcesses(dateFrom: string = '',
               dateUntil: string = '',
               search: string = ''): Observable<Array<IWorkflowProcess>> {
    const param = {
      date_from: dateFrom,
      date_until: dateUntil
    };
    const searchStr = !this.isLikeAuchanMode() ?`?search=${search}`:'';
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes${searchStr}`, param).pipe(
      map(result => {
        console.log(result);
        const processes: Array<IWorkflowProcess> = result.report.map(t => mapProcessFromService(t));
        return processes;
      })
    );

  }

  getProcess(processId: string): Observable<IWorkflowProcess> {
    const param = {};
    if (this.isLikeAuchanMode()) {
      return this.getWorkflowData(`audit_pack.get_audit_process?processId=${processId}`).pipe(
        map(
          result => {
            console.log(result);
            return mapAuchanAuditProcessesFromService(result[0]);
            //return result.report[0].map(item => mapProcessFromService(item));
          }
        )
      );
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}`, param).pipe(
        map(result => {
          const process: IWorkflowProcess = result.report.length ? mapProcessFromService(result.report[0]) : {...emptyWorkflowProcess};
          return process;
        })
      );
    }
  }

  postProcess(processId: string, partyId: string = '', operation: string, action: string = ''):Observable<IServiceResponse>{
    const param = {
      party_id: partyId
    };
    const body = '';
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}?operation=${operation}&action=${action}`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  startProcess(processTypeId: string, processName: string, processDescription: string, profile: object):Observable<IServiceResponse>{
    const param = {};
    const body = {
      'name': processName,
      'description': processDescription,
      'profile': profile
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/process-definitions/${processTypeId}/processes`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  getProcessStages(processId: string): Observable<Array<IWorkflowProcess>> {
    return of([]);
  }

  /**
   * Получить список задач
   * @param processType
   * @param searchString
   */

  getTasks(processType: string, searchString?: string, groupId?: string): Observable<Array<IWorkflowTask>> {
    const param = {
      process_type: processType ? processType : '-',
      //procType: '-',
      group_id: groupId ? groupId : '-'
    };
    if (searchString) {
      param['search_filter'] = searchString?searchString:'';
    }
    const searchStr = !this.isLikeAuchanMode() ? `?search=${searchString?searchString:''}`:'';

    console.log(param);
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks${searchStr}`, param).pipe(
      map(result => {
        console.log(result);
        const tasks: Array<IWorkflowTask> = result.report.map(item => {
          if (this.isLikeAuchanMode()) {
            return mapAuchanTaskFromService(item);
          } else {
            return mapTaskFromService(item);
          }
        });
        return tasks;
      })
    );

  }

  getTasksSupplierDemo(): Observable<Array<IWorkflowTask>> {

    return this.getWorkflowData(`ARTUCUL_PACK.getsuppldemoreport`).pipe(
      map(result => {
        console.log(result);
        const tasks: Array<IWorkflowTask> = result.map(item => {
            return mapAuchanTaskFromService(item);
        });
        return tasks;
      })
    );

  }

  /**
   * Получить конкретную задачу по ID
   * @param taskId
   */
  getTask(taskId: string): Observable<IWorkflowTask> {
    const param = {};

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}`, param).pipe(
      map(result => {
        if (result.report.length > 0) {
          console.log(result);
          const task: IWorkflowTask = this.isLikeAuchanMode() ? mapAuchanTaskFromService(result.report[0]):mapTaskFromService(result.report[0]);
          return task;
        } else {
          return {...emptyWorkflowTask};
        }
      })
    );
  }

  /**
   * Сохранить задачу
   * @param task
   */
  saveTask(task: IWorkflowTask): Observable<IServiceResponse> {
    const param = ''; //{};

    let body: any;
    if (this.isLikeAuchanMode()) {
      body = task.taskVariables;// this.mapTaskToService(task);
    } else {
      body = task.taskVariables;
    }

    console.log(body);

    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${task.id}`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  /**
   * Получить список типов событий
   */
  getEventTypes(): Observable<Array<IWorkflowEventTypeItem>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/events/types`, '').pipe(
      map(result => {
          console.log(result);
          return result.report.map(item => this.mapEventTypeFromService(item));
        }
      )
    );
  }

  mapEventTypeFromService(item): IWorkflowEventTypeItem {
    return {
      ...emptyWorkflowEventTypeItem,
      code: item['event_type_code'],
      name: item['event_type_name'],
      color: item['event_color']
    };
  }

  getEvents(processId: string, dateFrom: string = '', dateTo: string = '', eventType: string = '', merchCode: string = ''): Observable<Array<IWorkflowEvent>> {

    const param = {
      date_from: dateFrom,
      date_until: dateTo,
      event_type: eventType,
      merch_code: encodeURIComponent(merchCode)
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}/events`, param).pipe(
      map(result => {
          console.log(result);
          return result.report.map(item => this.mapEventFromService(item));
        }
      )
    );
  }

  mapEventFromService(item): IWorkflowEvent {
    return {
      ...emptyWorkflowEvent,
      dateCreate: item['date_create'] ? moment(item['date_create'], 'YYYYMMDD HH:mm:ss').toDate() : null,
      color: item['event_color'],
      data: item['event_data'],
      id: item['event_id'],
      name: item['event_name'],
      typeCode: item['event_type_code'],
      typeName: item['event_type_name'],
      processId: item['process_id'],
      profile: item['profile'],
      userIdCreated: item['user_id_created'],
      userIdOwner: item['user_id_owner'],
    };
  }


  /**
   * Отправить задачу
   * @param task
   * @param operation
   * @param action
   * @param userIdTo?
   */
  processTask(taskId: string, operation: string, action: string = '', userIdTo: string = ''): Observable<IServiceResponse> {
    const param = {
      taskId: taskId,
      operation: operation, //claim forward reassign complete reject
      action: action,
      useridto: userIdTo // id юзера которому отправить задачу
    };
    const body = ''; //{};

    console.log(param);
    if (this.isLikeAuchanMode()) {
      if (this.configurationManager.theme === 'auchan' || this.configurationManager.theme === 'portal' || this.configurationManager.configuration.api.host.includes('pilot-vrs')) {
        return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/taskoperation`, param, body).pipe(
          map((result: IServiceResponse) => {
            return result;
          })
        );
      } else {
         return of(emptyServiceResponse);
      }
    } else {
      return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}?operation=${operation}&action=${action}`, param, body).pipe(
        map((result: IServiceResponse) => {
          return result;
        })
      );
    }
  }

/*
  getGroups(processType: string): Observable<Array<IWorkflowGroup>> {
    const param = {
      process_type: processType ? processType : '-',
      //procType: '-',
      group_id: '-'
    };
    console.log(param);


    if (
      this.presenter.currentPartyId === '1000' || //ecr demo
      this.presenter.currentPartyId === '1006'  //ecr demo

    ) {
      switch (this.presenter.currentPartyId) {
        case "1000":
          const groups: Array<IWorkflowGroup> = wfEcrGroups.map(item => this.mapGroupFromService(item));
          return of(groups);
        case "1006":
          const groupsRd: Array<IWorkflowGroup> = wfEcrGroupsRd.map(item => this.mapGroupFromService(item));
          return of(groupsRd);

        default:
          return of(null);

      }
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/groupstasklist`, param).pipe(
        map(result => {
          console.log(result);
          const groups: Array<IWorkflowGroup> = result.report.map(item => this.mapGroupFromService(item));
          return groups;
        })
      );
    }
  }
*/

  /**
   * Получить список групп New оптимизированный
   * @param processType
   * @login login
   */
  getGroupsApexproxy(processType: string, login: string): Observable<Array<IWorkflowGroup>> {
    return this.getWorkflowData(`audit_pack.groupstasklist?T_PROCESS_NAME=${processType}&login=${login}`).pipe(
      map(
        result => {
          return result.map(item => this.mapGroupFromService(item));
        }
      )
    );
  }

  /**
   * Получить список файлов задачи
   * @param taskId
   */
  getTaskFiles(taskId: string): Observable<any> {
    const param = {};

    if (this.configurationManager.theme === 'unicredit') {
      const fileInfos: Array<IWorkflowFileInfo> = MockWorkflowFiles.report.map(item => this.mapFileInfoFromService(item));
      return of(fileInfos);
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/files`, param).pipe(
        map(result => {
          console.log(result);
          const fileInfos: Array<IWorkflowFileInfo> = result.report.map(item => this.mapFileInfoFromService(item));
          return fileInfos;
        })
      );
    }
  }

  /**
   * Получить список cайтов задачи
   * @param taskId
   */
  getTaskSites(taskId: string): Observable<Array<ISite>> {
    const param = {};

    if (this.presenter.currentPartyId === '1006') {
      const sites: Array<ISite> = [];

      taskSites_ecr_rd.forEach((item, idx) => {
        sites.push({
          ...emptySite,
          id: idx.toString(),
          code: item.data && item.data['7'] ? item.data['7'] : '',
          name: item.data && item.data['8'] ? item.data['8'] : '',
          address: item.data && item.data['20'] ? item.data['20'] : '',
          data: item.data ? item.data : {},
          schema: item.schema ? item.schema : {}
        });
      });
      return of(sites);
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/sites`, param).pipe(
        map(result => {
          console.log(result);
          const sites: Array<ISite> = [];
          result.report.forEach((item, idx) => {
            sites.push({
              ...emptySite,
              id: idx.toString(),
              code: item.code ? item.code : item.data && item.data['7'] ? item.data['7'] : '',
              name: item.name ? item.name : item.data && item.data['8'] ? item.data['8'] : '',
              address: item.data && item.data['20'] ? item.data['20'] : '',
              data: item.data ? item.data : {},
              schema: item.schema ? item.schema : {}
            });
          });
          return sites;
        })
      );
    }
  }

  /**
   * Получить конкретный cайт задачи
   * @param taskId
   */
  getTaskSite(taskId: string, siteId: string): Observable<ISite> {
    const param = {};

    if (this.configurationManager.theme === 'unicredit') {
      return of(null);
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/sites/${siteId}`, param).pipe(
        map(result => {
          console.log(result);
          const item = result.report[0];
          const site: ISite = {...emptySite, code: item.code, name: item.name, data: item.data ? item.data : {}, schema: item.schema ? item.schema : {}};
          return site;
        })
      );
    }
  }


  /**
   * Получить конкретный файл приаттаченный к задаче
   * @param taskId
   * @param fileId
   */
  getTaskFile(taskId: string, fileId: string): Observable<IWorkflowFile> {
    if (this.configurationManager.theme === 'unicredit') {
      //const file: IWorkflowFile = this.mapFileFromService(MockWorkflowFile.report[0]);
      //return of(file);
      return of(null)
    } else {

      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/files/${fileId}`, {}).pipe(
        map(result => {
          if (result.report.length > 0) {
            const file: IWorkflowFile = this.mapFileFromService(result.report[0]);
            return file;
          } else {
            return {...emptyWorkflowFile};
          }
        })
      );
    }
  }

  getTaskFileWithoutCheck(taskId: string, fileId: string, filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/AttachmentsOp/GetAttachment:1.0?TaskIDin=${taskId}&fileIDin=${fileId}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  /**
   * Прикрепить файл к задаче
   * @param taskId
   * @param file
   */
  attachFileToTask(taskId: string, file: IWorkflowFile): Observable<any> {

    const body = {
      "filename": file.filename,
      "description": file.description,
      "content": file.content
    };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/files`, {}, body).pipe(
      map(result => {
        return result;
      })
    );

    //return of(emptyServiceResponse);
  }

  /**
   * Прикрепить файл
   * @param file
   */
  attachFile(file: IWorkflowFile): Observable<any> {

    const body = {
      "filename": file.filename,
      "description": file.description,
      "content": file.content
    };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/files`, {}, body).pipe(
      map(result => {
        return result;
      })
    );

    //return of(emptyServiceResponse);
  }


  /**
   * Получить карточку процесса в Excel
   * @param processId
   * @param filename
   */

  getProcessCardExcel(processId: string, filename: string, reportType: string = 'GET_PROCHISTORY_TARIF'): Observable<IWorkflowFile> {
    ///birt/frameset?__report=GET_PROCHISTORY_ARTIKUL_report.rptdesign&PROCESS_INSTANCE_ID_IN=36255&__format=xls
    const header = {
      fileUrl: `/birt/frameset?__report=${reportType}.rptdesign&PROCESS_INSTANCE_ID_IN=${processId}&__format=xls`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapProcessExcelFileFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  mapProcessExcelFileFromService(item: object): IWorkflowFile {
    const file: IWorkflowFile = {
      ...emptyWorkflowFile,
      fileId: '',
      filename: decodeURIComponent(item['FileName']),
      content: item['Report']
    };
    return file;
  }


  /**
   * Получить список задач по процессу
   * @param processId
   */
  getProcessTasks(processId: string): Observable<Array<IWorkflowTask>> {
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}/tasks`, param).pipe(
      map(result => {
        const tasks: Array<IWorkflowTask> = result.report.map(item => {
          if (this.isLikeAuchanMode()) {
            return mapAuchanTaskFromService(item);
          } else {
            return mapTaskFromService(item);
          }
        });
        return tasks;
      })
    );
  }


  /**
   * Получить список начислений по процессу
   * @param processId
   * @param merchCode
   * @param siteCode
   * @param itemCode
   * @param regionCode
   */
  getProcessAccruals(processId: string, merchCode: string ='', siteCode: string = '', itemCode: string = '',  regionCode: string = ''): Observable<Array<IWorkflowBonusTaskItem>> {
    const param = ''; /* {
      item_code: itemCode,
      site_code: siteCode
    };*/
    const body = {
      merch_code: merchCode,
      region_code: regionCode,
      item_code: itemCode,
      site_code: siteCode
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/reports/processes/${processId}/accruals`, param, body).pipe(
      map(result => {

        //return result.map(item => this.mapAccrualFromService(item));

        const tasks: Array<IWorkflowBonusTaskItem> = result.report.map(item => {
          if (this.isLikeAuchanMode()) {
            //return mapAuchanTaskFromService(item);
            return null;
          } else {

            return this.mapAccrualFromService(item);
          }
        });

        console.log(tasks);

        return tasks;


      })
    );
  }

  /**
   * Получить список начислений по palfxt
   * @param taskId
   * @param merchCode
   * @param siteCode
   * @param itemCode
   * @param regionCode
   */
  getTaskAccruals(taskId: string,  merchCode: string, siteCode: string = '', itemCode: string = '', regionCode: string = ''): Observable<Array<IWorkflowBonusTaskItem>> {
    const param = ''; /*{
      merch_code: merchCode,
      item_code: itemCode,
      site_code: siteCode
    };*/
    const body = {
      merch_code: merchCode,
      region_code: regionCode,
      item_code: itemCode,
      site_code: siteCode
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/accruals`, param, body).pipe(
      map(result => {

        //return result.map(item => this.mapAccrualFromService(item));

        const accruals: Array<IWorkflowBonusTaskItem> = result.report.map(item => {
            return this.mapAccrualFromService(item);
        });
        console.log(accruals);

        return accruals;
      })
    );
  }

  mapAccrualFromService(item): IWorkflowBonusTaskItem {

    return {
      ...emptyWorkflowBonusTaskItem,
      accrualId: item['accrual_id'],
      bonusApproved: item['bonus_approved'],
      bonusCalculated: item['bonus_calculated'],
      itemCode: item['item_code'],
      itemName: item['item_name'],
      merchCode: item['merch_code'],
      merchName: item['merch_name'],
      needPhoto: item['need_photo'],
      processId: item['process_id'],
      profile: item['profile'],
      quantityFact: item['quantity_fact'],
      quantityPlan: item['quantity_plan'],
      siteCode: item['site_code'],
      siteName: item['site_name'],

      icon: null,
      img: '',

      iconSrc: 'edit',

      isSelected: {needPhoto: item['need_photo']},

      imageName: item['image_name'],

    };

  }

  putAccrualBonus(processId: string, accrualId: number, bonus: string): Observable<IServiceResponse> {
    const param = {amount: bonus};
    const body = ''; // {}; //{amount: bonus};

    console.log(body);

    //?amount=${bonus}

    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}/accruals/${accrualId}`, param, body).pipe(
      map((result: IServiceResponse) => {
        console.log(result);
        return result;
      })
    );
  }




  getTaskAccrualFile(taskId: string, accrualId: number): Observable<IWorkflowFile> {

      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/accruals/${accrualId}/images`, {}).pipe(
        map(result => {
          if (result.report.length > 0) {
            const file: IWorkflowFile = this.mapFileFromService(result.report[0]);
            return file;
          } else {
            return {...emptyWorkflowFile};
          }
        })
      );
  }


  getAccrualFile(processId: string, accrualId: number): Observable<IWorkflowFile> {

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}/accruals/${accrualId}/images`, {}).pipe(
      map(result => {
        if (result.report.length > 0) {
          const file: IWorkflowFile = this.mapAccrualFileFromService(result.report[0]);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  /**
   * Прикрепить к бонусам ММЛ фото
   * @param taskId
   * @param file
   */
  attachAccrualFile(processId: string, accrualId: string, file: IWorkflowFile): Observable<any> {

    const body = {
      "file": file.content,
      "file_name": file.filename
    };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/processes/${processId}/accruals/${accrualId}/images`, {}, body)
      .pipe(
      map(result => {
        console.log(result);
        let file: IWorkflowFile;
          if (result.report.length > 0) {
            file = this.mapAccrualFileFromService(result.report[0]);
            return file;
          } else {
            return {...emptyWorkflowFile};
          }
          return file;
        })
      );

  }

  /**
   * Прикрепить к бонусам ММЛ фото
   * @param taskId
   * @param file
   */
  attachTaskAccrualFile(taskId: string, accrualId: string, file: IWorkflowFile, photoAction: string = 'new'): Observable<any> {

    const body = {
      "file": file.content,
      "file_name": file.filename
    };

    const param = '';

    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/accruals/${accrualId}/images?photo_action=${photoAction}`, param, body)
      .pipe(
        map(result => {
          console.log(result);
          let file: IWorkflowFile;
          if (result.report.length > 0) {
            file = this.mapAccrualFileFromService(result.report[0]);
            return file;
          } else {
            return {...emptyWorkflowFile};
          }
          return file;
        })
      );

  }

  mapAccrualFileFromService(item: object): IWorkflowFile {
    const file: IWorkflowFile = {
      ...emptyWorkflowFile,
      fileId: '',
      filename: item['file_name'],
      content: item['file']
    };
    return file;
  }



  /**
   * Получить специфичные данные из сервиса APEX
   * @param param
   */
  getWorkflowData(param: string): Observable<Array<any>> {
    const header = {
      operationURL: param
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(
        result => {
          console.log(result);
          if (Array.isArray(result.report)) {
            return result.report;
          } else {
            return [];
          }
        }
        /*
        ,
        catchError(error => {
          console.log(error);
          return of([]);
        })
         */
      )
    );
  }


  /**
   * Сохранить данные в сервис APEX
   * @param param
   * @param body
   */
  putWorkflowData(param: string, body: any): Observable<IServiceResponse> {
    const header = {
      operationURL: param
    };

    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/putapexproxy`, header, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  getTasksExportGica(processId: string): Observable<Array<any>> {
    const header = {
      operationURL: `tarif_pack.get_ir_task?process_id_in=${processId}&pa1_in=-&pa2_in=-`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(
        result => {
          console.log(result);

          if (Array.isArray(result.report[0]['irtaskData']['irtaskData_row'])) {
            return result.report[0]['irtaskData']['irtaskData_row']; //result.report;
          } else if (result.report[0]['irtaskData']) {
            return [result.report[0]['irtaskData']['irtaskData_row']];
          } else {
            return [];
          }
        }
      )
    );
  }

  mapTasksExportGicaFromService(item): IWorkflowIrTask {
    return {
      ...emptyWorkflowIrTask,
      rid: item['IRADMIN_ID'],
      dateStart: moment(item['DATE_TASK'], 'DD.MM.YYYY').toDate(),
      userId: item['USER_TASK'],
      userName: item['USER_TASK'],
      statusCode: item['TASK_STATUS']
      //: t['ID'],  //"35025"
    };
  }


  /**
   * Получить список тарифов для процесса и граппы
   * @param processId
   * @param grappaCode
   */
  getTariffsList(processId: string, grappaCode: string = 'xx'): Observable<Array<IWorkflowTariffItem>> {
    return this.getWorkflowData(`tarif_pack.get_tariff?process_id_in=${processId}&list_num_in=${grappaCode}`).pipe(
      map(
        result => {
          console.log(result);
          return result.map(item => this.mapTariffItemFromService(item));
        }
      )
    );
  }

  mapTariffItemFromService(item): IWorkflowTariffItem {
    return {
      ...emptyWorkflowTariffItem,
      num: item['ROWIDX'],
      grappaCode: item['LIST_NAME'],
      articleCode: item['PRODUCT_NUM'],
      articleName: item['PRODUCT_NAME'],
      newPrice: item['NEW_ITOG'],
    };
  }


  /**
   * Получить список файлов тарифов
   * @param processId
   */
  getTariffsFiles(processId: string): Observable<Array<IWorkflowTariffFile>> {
    return this.getWorkflowData(`tarif_pack.get_tarif_files?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result.map(item => this.mapTariffFileFromService(item));
        }
      )
    );
  }

  mapTariffFileFromService(item): IWorkflowTariffFile {
    return {
      ...emptyWorkflowTariffFile,
      //: item['rownum'],
      tariffFileId: item['TARIF_FILES_ID'],
      //: item['PROCESS_ID'],
      isActive: item['IS_ACTIVE'] === '1',
      //: item['IS_ACTIVE2'],
      id: item['FILES_ID'],
      //: item['FILES_GUID'],
      filename: item['FILENAME'],
      dateCreate: moment(item['DATE_UPLOAD'], 'DD.MM.YYYY').toDate(),
      dateUpdate: moment(item['DATE_UPLOAD'], 'DD.MM.YYYY').toDate(),
      userName: item['WHO_UPLOAD'],
      filesize: item['filesize'],
    };
  }


  /**
   * Получить файл тарифов, который прикреплен к задаче
   * @param taskId
   * @param fileId
   */

  getTarifFile(taskId: string, fileId: string): Observable<IWorkflowFile> {
    if (this.configurationManager.theme === 'unicredit') {
      //const file: IWorkflowFile = this.mapFileFromService(MockWorkflowFile.report[0]);
     // return of(file);
      return of(null);
    } else {

      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/files/${fileId}`, {}).pipe(
        map(result => {
          if (result.report.length > 0) {
            const file: IWorkflowFile = this.mapFileFromService(result.report[0]);
            return file;
          } else {
            return {...emptyWorkflowFile};
          }
        })
      );
    }
  }

  /* //Прикрепить к задаче файл тарифов
  attachTarifFile(taskId: string, file: IWorkflowFile):Observable<IServiceResponse> {

    const body = {
      "filename": file.filename,
      "description": file.description,
      "content": file.content
    };
    this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/tarifffiles`, {}, body).subscribe(
      resultLoad => {
        console.log(resultLoad);
        return resultLoad;
      },
      error=>{
        console.log(error);
      }
    );
    return of(emptyServiceResponse);
  }
  */


  /**
   * Проверка загруженного файла тарифов, что это карточка Меркуриаль
   * @param tariffFileId
   */
  checkTariffFile(tariffFileId: string): Observable<IServiceResponse> {
    const header = {
      operationURL: `/rest/services/TarifChangeProcess/Processes/Subprocess/TarifFileParse:1.0?tarif_files_id=${tariffFileId}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/lcproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  /**
   * Прикрепить к задаче файл тарифов с проверкой на карточку Меркуреаль
   * @param taskId
   * @param file
   */
  attachTarifFileWithCheck(taskId: string, file: IWorkflowFile): Observable<IServiceResponse> {

    const body = {
      "filename": file.filename,
      "description": file.description,
      "content": file.content
    };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks/${taskId}/tarifffiles`, {}, body)
      .pipe(
        mergeMap(result => {
          console.log(result);
          return this.checkTariffFile(result['tarif_files_id']);
        })
      );

  }

  /**
   * Сделать активным файл тарифов
   * @param processId
   * @param fileId
   */
  setActiveTariffFile(processId: string, fileId: string): Observable<Array<IWorkflowTariffItem>> {

    return this.getWorkflowData(`tarif_pack.SetTarifFilesActive?PROCESSID_IN=${processId}&files_active_id=${fileId}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }


  /**
   * Получить список файлов тарифов
   * @param processId
   */
  getActiveTariffFile(processId: string,
                      filename: string = 'test.xls')
    : Observable<IWorkflowFile> {
    const header = {
      fileUrl: `/apex/livecycle.tarif_pack.download_active_file?PROCESSID_IN=${processId}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );

  }


  ////////////////////////////////////////////////
  //////////////// Создание артикулов ////////////
  ////////////////////////////////////////////////



  /**
   * Получить шапку артикулов для процесса
   * @param processId
   */
  getHeadArticles(processId: string): Observable<IWorkflowHeadArticles> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikuls_head?PROCESSID_IN=${processId}&USERNAME_IN=`).pipe(
      map(
        result => {
          return this.mapHeadArticlesFromService(result[0]);
        }
      )
    );
  }

  putHeadArticles(headArticles: IWorkflowHeadArticles, typeOperation = '3'): Observable<IServiceResponse> {
    const param = {};
    const body = this.mapHeadArticlesToService(headArticles, typeOperation);

    console.log(body);


    return this.putWorkflowData(`ARTUCUL_PACK.add_edit_ARTIKULS_HEAD`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  mapHeadArticlesFromService(item): IWorkflowHeadArticles {

    return {
      ...emptyWorkflowHeadArticles,
      id: item['ID'],
      processId: item['PROCESSID'],
      warehouse: item['WHOUSE'],
      extra: item['EXTRA'],
      itemCount: item['ITEMCOUNT'],
      pricePerItem: item['PRICEPERITEM'],
      market: item['SEC'],
      segment: item['RAY'],
      isDirectTransit: item['DIRECTFLD'],
      isImported: item['IMPORTFLD'] === "1",
      typeArticle: item['TYPEARTICUL'],
      segmentDescription: item['RAYDSC'],
      marketDescription: item['SECDSC'],
      readonly: item['READONLY'] === "1",
      marketReadonly: item['SECREADONLY'] === "1",
      plan: item['plan'],
      fact: item['fact'],
      filter: item['FILTER'],
      guaranteeStatus: item['ISGUARANTEE'],
      guaranteeStatusDescription: item['ISGUARANTEE_D'],
      guaranteeFrom: item['ISGUARANTEE_FROM'] ? moment(item['ISGUARANTEE_FROM'], 'DD.MM.YYYY').toDate() : null,
      guaranteeTo: item['ISGUARANTEE_TO'] ? moment(item['ISGUARANTEE_TO'], 'DD.MM.YYYY').toDate() : null,
      flgShelfLife: item['FLG_SHELF_LIFE'],
      shelfLifeComment: item['SHELF_LIFE_COMMENT'],
      atakLillapois: item['ATAK_LILLAPOIS'],

    };
  }

  mapHeadArticlesToService(item: IWorkflowHeadArticles, typeOperation): object {
    const result = {


      ID_IN: encodeURIComponent(item.id),
      PROCESSID_IN: encodeURIComponent(item.processId),
      WHOUSE_IN: encodeURIComponent(item.warehouse),
      EXTRA_IN: encodeURIComponent(item.extra),
      ITEMCOUNT_IN: item.itemCount,
      PRICEPERITEM_IN: item.pricePerItem,
      SEC_IN: encodeURIComponent(item.market),
      RAY_IN: encodeURIComponent(item.segment),
      DIRECTFLD_IN: encodeURIComponent(item.isDirectTransit),
      IMPORTFLD_IN: item.isImported ? "1" : "0",
      TYPEARTICUL_IN: encodeURIComponent(item.typeArticle),
      //RAYDSC_IN: encodeURIComponent(item.segmentDescription),
      //SECDSC_IN: encodeURIComponent(item.marketDescription),
      //READONLY_IN: item.readonly?"1":"0",
      //SECREADONLY_IN: item.marketReadonly?"1":"0",
      //plan_IN: item.plan,
      //fact_IN: item.fact,
      //FILTER_IN: encodeURIComponent(item.filter),
      add_del_edit: typeOperation ? typeOperation : "3",

      REJECT_CODIF_IN: "",
      REJECT_CODIF_NOTE_IN: "",
      REJECT_CODIF_NOTE_ONE_IN: "",

      ISGUARANTEE_IN: encodeURIComponent(item.guaranteeStatus),
      //ISGUARANTEE_D_IN: encodeURIComponent(item.guaranteeStatusDescription),
      ISGUARANTEE_FROM_IN: item.guaranteeFrom ? moment(item.guaranteeFrom).format('DD.MM.YYYY') : "",
      ISGUARANTEE_TO_IN: item.guaranteeTo ? moment(item.guaranteeTo).format('DD.MM.YYYY') : "",
      //FLG_SHELF_LIFE_IN: encodeURIComponent(item.flgShelfLife),
      //SHELF_LIFE_COMMENT_IN: encodeURIComponent(item.shelfLifeComment),
      //ATAK_LILLAPOIS_IN: encodeURIComponent(item.atakLillapois),


    };
    return result;
  }


  getCreateArticleGrappaPrices(articleId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikul_priceses?artikuls_id_in=${articleId}`).pipe(
      map(
        result => {
          return result.map (data => (
            {
              num: data['grappa'],
              id: data['id'],
              articleId: data['artikuls_id'],
              grappaCode: data['grappa'],
              grappaName: data['grappa_name'],
              price: data['price'],
              infl: data['infl']

            }
          ));
        }
      )
    );
  }



  /**
   * получить список рынков
   */
  getMarketsList(): Observable<Array<IWorkflowNomenclatureItem>> {
    return this.getWorkflowData('ARTUCUL_PACK.get_market?ARTIKULS_HEAD_ID_IN=323').pipe(
      map(
        result => {
          return result.map(item => this.mapNomenclatureItemFromService(item));
        }
      )
    );
  }


  /**
   * Получить список сегментов по коду рынка
   * @param marketCode
   */
  getSegmentsList(marketCode): Observable<Array<IWorkflowNomenclatureItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_segment?ARTIKULS_HEAD_ID_IN=323&PARENT_CODE_IN=${marketCode}`).pipe(
      map(
        result => {
          return result.map(item => this.mapNomenclatureItemFromService(item));
        }
      )
    );
  }

  mapNomenclatureItemFromService(item): IWorkflowNomenclatureItem {
    const name: string = item['NAME'] ? item['NAME'] : '';
    return {
      ...emptyWorkflowNomenclatureItem,
      code: item['CODE'],
      name: name.trim(),
      parentCode: item['PARENT_CODE']
    };
  }


  /**
   * Получить список артикулов для шапки и установленных фильтровв
   * @param headArticlesId
   * @param partEnterStr
   * @param statusArticlesStr
   * @param codeAssortmentStr
   * @param isCreatedForMoscow
   */
  getArticlesFilterList(headArticlesId: string,
                        partEnterStr: string,
                        statusArticlesStr: string,
                        codeAssortmentStr: string,
                        isCreatedForMoscow: string
  ): Observable<Array<IWorkflowArticleItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikuls?ARTIKULS_HEAD_ID_IN=${headArticlesId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`).pipe(
      map(
        result => {
          return result.map(item => this.mapArticleItemFromService(item));
        }
      )
    );
  }

  getArticles2FilterList(headArticlesId: string,
                        partEnterStr: string,
                        statusArticlesStr: string,
                        codeAssortmentStr: string,
                        isCreatedForMoscow: string
  ): Observable<Array<IWorkflowArticleItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikuls2?ARTIKULS_HEAD_ID_IN=${headArticlesId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`).pipe(
      map(
        result => {
          return result.map(item => this.mapArticleItemFromService(item));
        }
      )
    );
  }

  getArticlesStrFilterList(headArticlesId: string,
                        partEnterStr: string,
                        statusArticlesStr: string,
                        codeAssortmentStr: string,
                        isCreatedForMoscow: string
  ): Observable<Array<IWorkflowArticleStrItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikuls?ARTIKULS_HEAD_ID_IN=${headArticlesId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`).pipe(
      map(
        result => {
          return result.map(item => this.mapArticleStrItemFromService(item));
        }
      )
    );
  }


  getArticlesStr2FilterList(headArticlesId: string,
                         partEnterStr: string,
                         statusArticlesStr: string,
                         codeAssortmentStr: string,
                         isCreatedForMoscow: string
  ): Observable<Array<IWorkflowArticleStrItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikuls2?ARTIKULS_HEAD_ID_IN=${headArticlesId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`).pipe(
      map(
        result => {
          return result.map(item => this.mapArticleStrItemFromService(item));
        }
      )
    );
  }



  /**
   * Сохранить данные по артикулу
   * @param articleItem
   * @param typeOperation
   */
  putArticle(articleItem: IWorkflowArticleItem, typeOperation = '3'): Observable<IServiceResponse> {
    const param = {};
    const body = this.mapArticleItemToService(articleItem, typeOperation);

    console.log(JSON.stringify(body));

    return this.putWorkflowData(`ARTUCUL_PACK.add_edit_ARTIKULS`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  mapArticleItemFromService(item): any {
    return {
      ...emptyWorkflowArticleItem,
      id: item['ID'],
      artikulsHeadId: item['ARTIKULS_HEAD_ID'],
      username: item['USERNAME'],
      orderNum: item['ORDER_NUM'],
      rowIdx: item['ROW_IDX'],
      productName: item['PRODUCT_NAME'].toUpperCase(), //ToDO Auchan
      barcode: item['BARCODE'],
      productCode: item['PRODUCT_CODE'],
      priceWithoutNds: item['PRICE_BEZNDS'],
      priceWithoutNdsOld: item['PRICE_BEZNDS_OLD'],
      discountAccount: item['DISCOUNT_ACCOUNT'],
      ndsRate: item['NDS_RATE'],
      numberInBox: item['NUMBER_IN_BOX'],
      okpd: item['OKPD'],
      fromCountry: item['FROM_COUNTRY'],
      fromCountryDecode: item['FROM_COUNTRY_DECODE'],
      buyUnit: item['BUY_UNIT'],
      buyUnitDecode: item['BUY_UNIT_DECODE'],
      saleUnit: item['SALE_UNIT'],
      saleUnitDecode: item['SALE_UNIT_DECODE'],
      characteristicsProduct: item['CHARACTERISTICS_PRODUCT'],
      productType: item['PRODUCT_TYPE'],
      productTypeDecode: item['PRODUCT_TYPE_DECODE'],
      auchanProd: item['AUCHAN_PROD'],
      productCategory: item['PRODUCT_CATEGORY'],
      comments: item['COMMENS'],
      height: item['HEIGHT'],
      width: item['WIDTH'],
      depth: item['DEPTH'],
      productShelfLife: item['PRODUCT_SHELF_LIFE'],
      storageTmin: item['STORAGE_T_MIN'],
      storageTmax: item['STORAGE_T_MAX'],
      haveAlcogol: item['HAVE_ALCOGOL'],
      alcogolProcent: item['ALCOGOL_PROCENT'],
      alcogolCode: item['ALCOGOL_CODE'],
      alcogolContent: item['ALCOGOL_CONTENT'],
      collectionNum: item['COLLECTION_NUM'],
      collectionStart: item['COLLECTION_START'] ? moment(item['COLLECTION_START'], 'DD.MM.YYYY').toDate() : null,
      collectionEnd: item['COLLECTION_END'] ? moment(item['COLLECTION_END'], 'DD.MM.YYYY').toDate() : null,
      family: item['FAMILY'],
      category: item['CATEGORY'],
      addBarcode: item['ADD_BAR_CODE'],
      nationPrice: item['NATION_PRICE'],
      param1: item['PARAM1'],
      param2: item['PARAM2'],
      param3: item['PARAM3'],
      param4: item['PARAM4'],
      param5: item['PARAM5'],
      param6: item['PARAM6'],
      param7: item['PARAM7'],
      param8: item['PARAM8'],
      param9: item['PARAM9'],
      param10: item['PARAM10'],
      param11: item['PARAM11'],
      param12: item['PARAM12'],
      param13: item['PARAM13'],
      param14: item['PARAM14'],
      param15: item['PARAM15'],
      rejectBuyerCode: item['REJECT_B'],
      rejectBuyerNote: item['REJECT_B_NOTE'],
      rejectBuyerDecode: item['REJECT_B_DECODE'],
      rejectCodifCode: item['REJECT_CODIF'],
      rejectCodifNote: item['REJECT_CODIF_NOTE'],
      rejectCodifDecode: item['REJECT_CODIF_DECODE'],
      inputPrice: item['INPUT_PRICE'],
      articleStatus: item['ARTICUL_STATUS'],
      assortmentCode: item['ASSORTMENT_CODE'],
      moscowArt: item['MOSCOW_ART'],
      artCodeNew: item['ART_CODE_NEW'],
      rejColor: item['REJCOLOR'],
      chbox: item['CHBOX'],
      prjcode: item['PRJCODE'],
      articleCloseCode: item['ARTIKUL_CLOSE_CODE'],
      articleCloseName: item['ARTIKUL_CLOSE_NAME'],
      dateInput: item['date_input'] ? moment(item['date_input'], 'DD.MM.YYYY').toDate() : null,
      collectionStart2: item['COLLECTION_START2'] ? moment(item['COLLECTION_START2'], 'DD.MM.YYYY').toDate() : null,
      collectionEnd2: item['COLLECTION_END2'] ? moment(item['COLLECTION_END2'], 'DD.MM.YYYY').toDate() : null,
      collectionStart3: item['COLLECTION_START3'] ? moment(item['COLLECTION_START3'], 'DD.MM.YYYY').toDate() : null,
      collectionEnd3: item['COLLECTION_END3'] ? moment(item['COLLECTION_END3'], 'DD.MM.YYYY').toDate() : null,
      collectionStart4: item['COLLECTION_START4'] ? moment(item['COLLECTION_START4'], 'DD.MM.YYYY').toDate() : null,
      collectionEnd4: item['COLLECTION_END4'] ? moment(item['COLLECTION_END4'], 'DD.MM.YYYY').toDate() : null,
      productNameNew: item['PRODUCT_NAME_NEW'],
      tobaccoPriceMin: item['TOBACCO_PRICE_MIN'],
      tobaccoPriceMax: item['TOBACCO_PRICE_MAX'],
      readonly: item['READONLY'] === "1",
      articleStatusNew: item['ARTICUL_STATUS_NEW'],
      reason: item['REASON'],
      reasonDescription: item['REASON_D'],
      reasonComment: item['REASON_COMMENT'],
      reasonUnified: item['REASON_UNIFIED'],
      minPrice: item['MIN_PRICE'],
      lotOrder: item['LOTORDER'],
      itemSale: item['ITEMSALE'],
      qInLote: item['Q_IN_LOTE'],
      egais: item['EGAIS'],
      itf14: item['ITF14'],
      atakLillapois: item['ATAK_LILLAPOIS'],
      itf14Amount: item['ITF14AMOUNT'],
      keyword: item['KEYWORD'],
      //region: item['REGION'],

      inflation: item['inflation'],

      bioorgani: item['bioorgani'],

      dietary: item['dietary'],
      farm: item['farm'],
      glutenfree: item['glutenfree'],
      halal: item['halal'],
      healthychoice: item['healthychoice'],
      highprotein: item['highprotein'],
      kosher: item['kosher'],
      lactosefree: item['lactosefree'],
      lowcarb: item['lowcarb'],
      sugarfree: item['sugarfree'],
      vegetarian: item['vegetarian'],


    };
  }


  mapArticleItemToService(item: IWorkflowArticleItem, typeOperation): object {

    const result = {
      ID_IN: encodeURIComponent(item.id),
      ARTIKULS_HEAD_ID_IN: encodeURIComponent(item.artikulsHeadId),
      USERNAME_IN: encodeURIComponent(item.username),
      ORDER_NUM_IN: encodeURIComponent(item.orderNum),
      ROW_IDX_IN: encodeURIComponent(item.rowIdx),
      PRODUCT_NAME_IN: encodeURIComponent(item.productName),
      BARCODE_IN: encodeURIComponent(item.barcode),
      PRODUCT_CODE_IN: encodeURIComponent(item.productCode),
      PRICE_BEZNDS_IN: encodeURIComponent(item.priceWithoutNds.toString()), //-1,
      //PRICE_BEZNDS_OLD: item.priceWithoutNdsOld,
      DISCOUNT_ACCOUNT_IN: encodeURIComponent(item.discountAccount.toString()),
      NDS_RATE_IN: encodeURIComponent(item.ndsRate.toString()),
      NUMBER_IN_BOX_IN: encodeURIComponent(item.numberInBox.toString()),
      OKPD_IN: encodeURIComponent(item.okpd),
      FROM_COUNTRY_IN: encodeURIComponent(item.fromCountry),
      //FROM_COUNTRY_DECODE: item.fromCountryDecode,
      BUY_UNIT_IN: encodeURIComponent(item.buyUnit),
      //BUY_UNIT_DECODE_IN: encodeURIComponent(item.buyUnitDecode),
      SALE_UNIT_IN: encodeURIComponent(item.saleUnit),
      //SALE_UNIT_DECODE: item.saleUnitDecode,
      CHARACTERISTICS_PRODUCT_IN: encodeURIComponent(item.characteristicsProduct),
      PRODUCT_TYPE_IN: encodeURIComponent(item.productType),
      //PRODUCT_TYPE_DECODE: item.productTypeDecode,
      AUCHAN_PROD_IN: encodeURIComponent(item.auchanProd),
      PRODUCT_CATEGORY_IN: encodeURIComponent(item.productCategory),
      COMMENS_IN: encodeURIComponent(item.comments),
      HEIGHT_IN: encodeURIComponent(item.height.toString()),
      WIDTH_IN: encodeURIComponent(item.width.toString()),
      DEPTH_IN: encodeURIComponent(item.depth.toString()),
      PRODUCT_SHELF_LIFE_IN: encodeURIComponent(item.productShelfLife.toString()),
      STORAGE_T_MIN_IN: encodeURIComponent(item.storageTmin.toString()),
      STORAGE_T_MAX_IN: encodeURIComponent(item.storageTmax.toString()),
      HAVE_ALCOGOL_IN: encodeURIComponent(item.haveAlcogol),
      ALCOGOL_PROCENT_IN: encodeURIComponent(item.alcogolProcent),
      ALCOGOL_CODE_IN: encodeURIComponent(item.alcogolCode),
      ALCOGOL_CONTENT_IN: encodeURIComponent(item.alcogolContent),
      COLLECTION_NUM_IN: encodeURIComponent(item.collectionNum),
      COLLECTION_START_IN: item.collectionStart ? moment(item.collectionStart).format('DD.MM.YYYY') : '',
      COLLECTION_END_IN: item.collectionEnd ? moment(item.collectionEnd).format('DD.MM.YYYY') : '',
      FAMILY_IN: encodeURIComponent(item.family),
      CATEGORY_IN: encodeURIComponent(item.category),
      ADD_BAR_CODE_IN: encodeURIComponent(item.addBarcode),
      //NATION_PRICE: item.nationPrice,
      PARAM1_IN: encodeURIComponent(item.param1),
      PARAM2_IN: encodeURIComponent(item.param2),
      PARAM3_IN: encodeURIComponent(item.param3),
      PARAM4_IN: encodeURIComponent(item.param4),
      PARAM5_IN: encodeURIComponent(item.param5),
      PARAM6_IN: encodeURIComponent(item.param6),
      PARAM7_IN: encodeURIComponent(item.param7),
      PARAM8_IN: encodeURIComponent(item.param8),
      PARAM9_IN: encodeURIComponent(item.param9),
      PARAM10_IN: encodeURIComponent(item.param10),
      PARAM11_IN: encodeURIComponent(item.param11),
      PARAM12_IN: encodeURIComponent(item.param12),
      PARAM13_IN: encodeURIComponent(item.param13),
      PARAM14_IN: encodeURIComponent(item.param14),
      PARAM15_IN: encodeURIComponent(item.param15),
      add_del_edit: typeOperation ? typeOperation : '3', //!!! Параметр операции    //1 add      2 del      3 edit      4- установить флаг Отменить ввод,      5 - отменить флаг      -6- установить флаг Все введено,      7 - отменить флаг Все введено
      REJECT_B_IN: encodeURIComponent(item.rejectBuyerCode),
      REJECT_B_NOTE_IN: encodeURIComponent(item.rejectBuyerNote),
      //REJECT_B_DECODE: item.rejectBuyerDecode,
      REJECT_CODIF_IN: encodeURIComponent(item.rejectCodifCode),
      REJECT_CODIF_NOTE_IN: encodeURIComponent(item.rejectCodifNote),
      //REJECT_CODIF_DECODE: item.rejectCodifDecode,
      INPUT_PRICE_IN: encodeURIComponent(item.inputPrice.toString()),
      ARTICUL_STATUS_IN: encodeURIComponent(item.articleStatus),
      ASSORTMENT_CODE_IN: encodeURIComponent(item.assortmentCode),
      MOSCOW_ART_IN: encodeURIComponent(item.moscowArt),
      ART_CODE_NEW_IN: encodeURIComponent(item.artCodeNew),
      //REJCOLOR: item.rejColor,
      //CHBOX: item.chbox,
      PRJCODE_IN: encodeURIComponent(item.prjcode),
      ARTIKUL_CLOSE_CODE_IN: encodeURIComponent(item.articleCloseCode),
      //ARTIKUL_CLOSE_NAME: item.articleCloseName,
      //date_input: item.dateInput?moment(item.dateInput).format('DD.MM.YYYY'):'',
      COLLECTION_START2_IN: item.collectionStart2 ? moment(item.collectionStart2).format('DD.MM.YYYY') : '',
      COLLECTION_END2_IN: item.collectionEnd2 ? moment(item.collectionEnd2).format('DD.MM.YYYY') : '',
      COLLECTION_START3_IN: item.collectionStart3 ? moment(item.collectionStart3).format('DD.MM.YYYY') : '',
      COLLECTION_END3_IN: item.collectionEnd3 ? moment(item.collectionEnd3).format('DD.MM.YYYY') : '',
      COLLECTION_START4_IN: item.collectionStart4 ? moment(item.collectionStart4).format('DD.MM.YYYY') : '',
      COLLECTION_END4_IN: item.collectionEnd4 ? moment(item.collectionEnd4).format('DD.MM.YYYY') : '',
      PRODUCT_NAME_NEW_IN: encodeURIComponent(item.productNameNew),
      TOBACCO_PRICE_MIN_IN: encodeURIComponent(item.tobaccoPriceMin),
      TOBACCO_PRICE_MAX_IN: encodeURIComponent(item.tobaccoPriceMax),
      //READONLY: item.readonly?"1":"0",
      ARTICUL_STATUS_NEW_IN: encodeURIComponent(item.articleStatusNew),
      //REASON: item.reason,
      //REASON_D: item.reasonDescription,
      //REASON_COMMENT: item.reasonComment,
      //REASON_UNIFIED: item.reasonUnified,
      MIN_PRICE_IN: encodeURIComponent(item.minPrice.toString()),
      LOTORDER_IN: encodeURIComponent(item.lotOrder),
      ITEMSALE_IN: encodeURIComponent(item.itemSale),
      Q_IN_LOTE_IN: encodeURIComponent(item.qInLote),
      EGAIS_IN: encodeURIComponent(item.egais),
      ITF14_IN: encodeURIComponent(item.itf14),
      SIGNOFTRACE_IN: "", //encodeURIComponent(item.atakLillapois),
      ITF14AMOUNT_IN: encodeURIComponent(item.itf14Amount),


      KEYWORD_IN: encodeURIComponent(item.keyword),

      //REGION_IN: '', //encodeURIComponent(item.region),

      //new_attributes

      sugarfree_in: encodeURIComponent(item.sugarfree),
      glutenfree_in: encodeURIComponent(item.glutenfree),
      bioorgani_in: encodeURIComponent(item.bioorgani),
      lactosefree_in: encodeURIComponent(item.lactosefree),
      lowcarb_in: encodeURIComponent(item.lowcarb),
      vegetarian_in: encodeURIComponent(item.vegetarian),
      highprotein_in: encodeURIComponent(item.highprotein),
      healthychoice_in: encodeURIComponent(item.healthychoice),
      dietary_in: encodeURIComponent(item.dietary),
      halal_in: encodeURIComponent(item.halal),
      kosher_in: encodeURIComponent(item.kosher),
      farm_in: encodeURIComponent(item.farm)


    };

    return result;
  }

  putArticleStr(articleItem: IWorkflowArticleStrItem, typeOperation = '3'): Observable<IServiceResponse> {
    const param = {};
    const body = this.mapArticleStrItemToService(articleItem, typeOperation);

    console.log(JSON.stringify(body));

    return this.putWorkflowData(`ARTUCUL_PACK.add_edit_ARTIKULS`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  mapArticleStrItemFromService(item): IWorkflowArticleStrItem {
    return {
      ...emptyWorkflowArticleStrItem,
      id: item['ID'],
      artikulsHeadId: item['ARTIKULS_HEAD_ID'],
      username: item['USERNAME'],
      orderNum: item['ORDER_NUM'],
      rowIdx: item['ROW_IDX'],
      productName: item['PRODUCT_NAME'],
      barcode: item['BARCODE'],
      productCode: item['PRODUCT_CODE'],
      priceWithoutNds: item['PRICE_BEZNDS'],
      priceWithoutNdsOld: item['PRICE_BEZNDS_OLD'],
      discountAccount: item['DISCOUNT_ACCOUNT'],
      ndsRate: item['NDS_RATE'],
      numberInBox: item['NUMBER_IN_BOX'],
      okpd: item['OKPD'],
      fromCountry: item['FROM_COUNTRY'],
      fromCountryDecode: item['FROM_COUNTRY_DECODE'],
      buyUnit: item['BUY_UNIT'],
      buyUnitDecode: item['BUY_UNIT_DECODE'],
      saleUnit: item['SALE_UNIT'],
      saleUnitDecode: item['SALE_UNIT_DECODE'],
      characteristicsProduct: item['CHARACTERISTICS_PRODUCT'],
      productType: item['PRODUCT_TYPE'],
      productTypeDecode: item['PRODUCT_TYPE_DECODE'],
      auchanProd: item['AUCHAN_PROD'],
      productCategory: item['PRODUCT_CATEGORY'],
      comments: item['COMMENS'],
      height: item['HEIGHT'],
      width: item['WIDTH'],
      depth: item['DEPTH'],
      productShelfLife: item['PRODUCT_SHELF_LIFE'],
      storageTmin: item['STORAGE_T_MIN'],
      storageTmax: item['STORAGE_T_MAX'],
      haveAlcogol: item['HAVE_ALCOGOL'],
      alcogolProcent: item['ALCOGOL_PROCENT'],
      alcogolCode: item['ALCOGOL_CODE'],
      alcogolContent: item['ALCOGOL_CONTENT'],
      collectionNum: item['COLLECTION_NUM'],
      collectionStart: item['COLLECTION_START'],
      collectionEnd: item['COLLECTION_END'],
      family: item['FAMILY'],
      category: item['CATEGORY'],
      addBarcode: item['ADD_BAR_CODE'],
      nationPrice: item['NATION_PRICE'],
      param1: item['PARAM1'],
      param2: item['PARAM2'],
      param3: item['PARAM3'],
      param4: item['PARAM4'],
      param5: item['PARAM5'],
      param6: item['PARAM6'],
      param7: item['PARAM7'],
      param8: item['PARAM8'],
      param9: item['PARAM9'],
      param10: item['PARAM10'],
      param11: item['PARAM11'],
      param12: item['PARAM12'],
      param13: item['PARAM13'],
      param14: item['PARAM14'],
      param15: item['PARAM15'],
      rejectBuyerCode: item['REJECT_B'],
      rejectBuyerNote: item['REJECT_B_NOTE'],
      rejectBuyerDecode: item['REJECT_B_DECODE'],
      rejectCodifCode: item['REJECT_CODIF'],
      rejectCodifNote: item['REJECT_CODIF_NOTE'],
      rejectCodifDecode: item['REJECT_CODIF_DECODE'],
      inputPrice: item['INPUT_PRICE'],
      articleStatus: item['ARTICUL_STATUS'],
      assortmentCode: item['ASSORTMENT_CODE'],
      moscowArt: item['MOSCOW_ART'],
      artCodeNew: item['ART_CODE_NEW'],
      rejColor: item['REJCOLOR'],
      chbox: item['CHBOX'],
      prjcode: item['PRJCODE'],
      articleCloseCode: item['ARTIKUL_CLOSE_CODE'],
      articleCloseName: item['ARTIKUL_CLOSE_NAME'],
      dateInput: item['date_input'],
      collectionStart2: item['COLLECTION_START2'],
      collectionEnd2: item['COLLECTION_END2'],
      collectionStart3: item['COLLECTION_START3'],
      collectionEnd3: item['COLLECTION_END3'],
      collectionStart4: item['COLLECTION_START4'],
      collectionEnd4: item['COLLECTION_END4'],
      productNameNew: item['PRODUCT_NAME_NEW'],
      tobaccoPriceMin: item['TOBACCO_PRICE_MIN'],
      tobaccoPriceMax: item['TOBACCO_PRICE_MAX'],
      readonly: item['READONLY'] === "1",
      articleStatusNew: item['ARTICUL_STATUS_NEW'],
      reason: item['REASON'],
      reasonDescription: item['REASON_D'],
      reasonComment: item['REASON_COMMENT'],
      reasonUnified: item['REASON_UNIFIED'],
      minPrice: item['MIN_PRICE'],
      lotOrder: item['LOTORDER'],
      itemSale: item['ITEMSALE'],
      qInLote: item['Q_IN_LOTE'],
      egais: item['EGAIS'],
      itf14: item['ITF14'],
      atakLillapois: item['ATAK_LILLAPOIS'],
      itf14Amount: item['ITF14AMOUNT'],
      keyword: item['KEYWORD'],
      //region: item['REGION'],

      inflation: item['inflation'],

      bioorgani: item['bioorgani'],

      dietary: item['dietary'],
      farm: item['farm'],
      glutenfree: item['glutenfree'],
      halal: item['halal'],
      healthychoice: item['healthychoice'],
      highprotein: item['highprotein'],
      kosher: item['kosher'],
      lactosefree: item['lactosefree'],
      lowcarb: item['lowcarb'],
      sugarfree: item['sugarfree'],
      vegetarian: item['vegetarian'],

      file: item['art_image']

    };
  }


  mapArticleStrItemToService(item: IWorkflowArticleStrItem, typeOperation): object {

    const result = {
      ID_IN: encodeURIComponent(item.id),
      ARTIKULS_HEAD_ID_IN: encodeURIComponent(item.artikulsHeadId),
      USERNAME_IN: encodeURIComponent(item.username),
      ORDER_NUM_IN: encodeURIComponent(item.orderNum),
      ROW_IDX_IN: encodeURIComponent(item.rowIdx),
      PRODUCT_NAME_IN: encodeURIComponent(item.productName),
      BARCODE_IN: encodeURIComponent(item.barcode),
      PRODUCT_CODE_IN: encodeURIComponent(item.productCode),
      PRICE_BEZNDS_IN: encodeURIComponent(item.priceWithoutNds.toString()), //-1,
      DISCOUNT_ACCOUNT_IN: encodeURIComponent(item.discountAccount.toString()),
      NDS_RATE_IN: encodeURIComponent(item.ndsRate.toString()),
      NUMBER_IN_BOX_IN: encodeURIComponent(item.numberInBox.toString()),
      OKPD_IN: encodeURIComponent(item.okpd),
      FROM_COUNTRY_IN: encodeURIComponent(item.fromCountry),
      BUY_UNIT_IN: encodeURIComponent(item.buyUnit),

      SALE_UNIT_IN: encodeURIComponent(item.saleUnit),
      CHARACTERISTICS_PRODUCT_IN: encodeURIComponent(item.characteristicsProduct),
      PRODUCT_TYPE_IN: encodeURIComponent(item.productType),
      AUCHAN_PROD_IN: encodeURIComponent(item.auchanProd),
      PRODUCT_CATEGORY_IN: encodeURIComponent(item.productCategory),
      COMMENS_IN: encodeURIComponent(item.comments),
      HEIGHT_IN: encodeURIComponent(item.height.toString()),
      WIDTH_IN: encodeURIComponent(item.width.toString()),
      DEPTH_IN: encodeURIComponent(item.depth.toString()),
      PRODUCT_SHELF_LIFE_IN: encodeURIComponent(item.productShelfLife.toString()),
      STORAGE_T_MIN_IN: encodeURIComponent(item.storageTmin.toString()),
      STORAGE_T_MAX_IN: encodeURIComponent(item.storageTmax.toString()),
      HAVE_ALCOGOL_IN: encodeURIComponent(item.haveAlcogol),
      ALCOGOL_PROCENT_IN: encodeURIComponent(item.alcogolProcent),
      ALCOGOL_CODE_IN: encodeURIComponent(item.alcogolCode),
      ALCOGOL_CONTENT_IN: encodeURIComponent(item.alcogolContent),
      COLLECTION_NUM_IN: encodeURIComponent(item.collectionNum),
      COLLECTION_START_IN: encodeURIComponent(item.collectionStart),
      COLLECTION_END_IN: encodeURIComponent(item.collectionEnd),
      FAMILY_IN: encodeURIComponent(item.family),
      CATEGORY_IN: encodeURIComponent(item.category),
      ADD_BAR_CODE_IN: encodeURIComponent(item.addBarcode),
      PARAM1_IN: encodeURIComponent(item.param1),
      PARAM2_IN: encodeURIComponent(item.param2),
      PARAM3_IN: encodeURIComponent(item.param3),
      PARAM4_IN: encodeURIComponent(item.param4),
      PARAM5_IN: encodeURIComponent(item.param5),
      PARAM6_IN: encodeURIComponent(item.param6),
      PARAM7_IN: encodeURIComponent(item.param7),
      PARAM8_IN: encodeURIComponent(item.param8),
      PARAM9_IN: encodeURIComponent(item.param9),
      PARAM10_IN: encodeURIComponent(item.param10),
      PARAM11_IN: encodeURIComponent(item.param11),
      PARAM12_IN: encodeURIComponent(item.param12),
      PARAM13_IN: encodeURIComponent(item.param13),
      PARAM14_IN: encodeURIComponent(item.param14),
      PARAM15_IN: encodeURIComponent(item.param15),
      add_del_edit: typeOperation ? typeOperation : '3', //!!! Параметр операции    //1 add      2 del      3 edit      4- установить флаг Отменить ввод,      5 - отменить флаг      -6- установить флаг Все введено,      7 - отменить флаг Все введено
      REJECT_B_IN: encodeURIComponent(item.rejectBuyerCode),
      REJECT_B_NOTE_IN: encodeURIComponent(item.rejectBuyerNote),
      //REJECT_B_DECODE: item.rejectBuyerDecode,
      REJECT_CODIF_IN: encodeURIComponent(item.rejectCodifCode),
      REJECT_CODIF_NOTE_IN: encodeURIComponent(item.rejectCodifNote),
      //REJECT_CODIF_DECODE: item.rejectCodifDecode,
      INPUT_PRICE_IN: encodeURIComponent(item.inputPrice.toString()),
      ARTICUL_STATUS_IN: encodeURIComponent(item.articleStatus),
      ASSORTMENT_CODE_IN: encodeURIComponent(item.assortmentCode),
      MOSCOW_ART_IN: encodeURIComponent(item.moscowArt),
      ART_CODE_NEW_IN: encodeURIComponent(item.artCodeNew),

      PRJCODE_IN: encodeURIComponent(item.prjcode),
      ARTIKUL_CLOSE_CODE_IN: encodeURIComponent(item.articleCloseCode),
      COLLECTION_START2_IN: encodeURIComponent(item.collectionStart2),
      COLLECTION_END2_IN: encodeURIComponent(item.collectionEnd2),
      COLLECTION_START3_IN: encodeURIComponent(item.collectionStart3),
      COLLECTION_END3_IN: encodeURIComponent(item.collectionEnd3),
      COLLECTION_START4_IN: encodeURIComponent(item.collectionStart4),
      COLLECTION_END4_IN: encodeURIComponent(item.collectionEnd4),
      PRODUCT_NAME_NEW_IN: encodeURIComponent(item.productNameNew),
      TOBACCO_PRICE_MIN_IN: encodeURIComponent(item.tobaccoPriceMin),
      TOBACCO_PRICE_MAX_IN: encodeURIComponent(item.tobaccoPriceMax),
      ARTICUL_STATUS_NEW_IN: encodeURIComponent(item.articleStatusNew),
      MIN_PRICE_IN: encodeURIComponent(item.minPrice.toString()),
      LOTORDER_IN: encodeURIComponent(item.lotOrder),
      ITEMSALE_IN: encodeURIComponent(item.itemSale),
      Q_IN_LOTE_IN: encodeURIComponent(item.qInLote),
      EGAIS_IN: encodeURIComponent(item.egais),
      ITF14_IN: encodeURIComponent(item.itf14),
      SIGNOFTRACE_IN: encodeURIComponent(item.atakLillapois),
      ITF14AMOUNT_IN: encodeURIComponent(item.itf14Amount),

      KEYWORD_IN: encodeURIComponent(item.keyword),

      sugarfree_in: encodeURIComponent(item.sugarfree),
      glutenfree_in: encodeURIComponent(item.glutenfree),
      bioorgani_in: encodeURIComponent(item.bioorgani),
      lactosefree_in: encodeURIComponent(item.lactosefree),
      lowcarb_in: encodeURIComponent(item.lowcarb),
      vegetarian_in: encodeURIComponent(item.vegetarian),
      highprotein_in: encodeURIComponent(item.highprotein),
      healthychoice_in: encodeURIComponent(item.healthychoice),
      dietary_in: encodeURIComponent(item.dietary),
      halal_in: encodeURIComponent(item.halal),
      kosher_in: encodeURIComponent(item.kosher),
      farm_in: encodeURIComponent(item.farm),

      ART_IMAGE_IN: item.file ? item.file : ''
    };

    return result;
  }

  // Изменить статус причину с вводом решений закупщика и кодификации для артикула
  setReasonReject(articleId: string, rejectBCode: string, rejectBNote: string, rejectCodifCode: string, rejectCodifNote: string, rejectCodifOne: string): Observable<any> {
    return this.getWorkflowData(`ARTUCUL_PACK.edit_approve_reject?ID_IN=${articleId}&REJECT_B_IN=${rejectBCode}&REJECT_B_NOTE_IN=${rejectBNote}&REJECT_CODIF_IN=${rejectCodifCode}&REJECT_CODIF_NOTE_IN=${rejectCodifNote}&REJECT_CODIF_ONE_IN=${rejectCodifOne}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }

  // Массовые операции кодификации при создании артикулов
  setCreateRejectCodifAll(processId: string, rejectCodifCode: string, rejectCodifNote: string, rejectCodifOne: string): Observable<any> {
    //"process_id_in","REJECT_CODIF_IN","REJECT_CODIF_NOTE_IN","REJECT_CODIF_ONE_IN"
    return this.getWorkflowData(`ARTUCUL_PACK.edit_all_approve_reject?process_id_in=${processId}&REJECT_CODIF_IN=${rejectCodifCode}&REJECT_CODIF_NOTE_IN=${rejectCodifNote}&REJECT_CODIF_ONE_IN=${rejectCodifOne}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );

  }

  //Скачать картинку по артикулу
  getArticleImage(articleId: string): Observable<any> {

    const param = {
      id: articleId
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/query/get_art_image`, param).pipe(
      map(result => {

          return result.report[0]['IMAGE']?result.report[0]['IMAGE']:'';
          //return result.report.map(item => this.mapEventFromService(item));
        }
      )
    );

  }

   //Прикрепить к артикулу картинку
  putArticleImage(articleId: string, file: any):Observable<IServiceResponse> {

    const body = {
      "id_in": articleId,
      "image_in": file
    };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/query/oper_art_image`, {}, body).pipe(
      map(result => {
        return result;
      })
    );

  }


  ////////////////////////////
  // Копирование артикулов ///
  ////////////////////////////

  /**
   * Получить список аттрибутов артикулов
   * @param articleId
   */
  getArticleAttributes(articleId: string): Observable<Array<IListItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_art_fields?artikuls_id_in=${articleId}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => (
            {
              id: item['COLNAMEENG'],
              code: item['COLNAME'],
              text: item['COLVALUE'],
              checked: item['CHBOX'] === 1
            }
          ));
        }
      )
    );
  }

  /**
   * Получить список аттрибутов артикулов
   * @param articleId
   */
  getCopyArticles(articleId: string): Observable<Array<IListItem>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_copy_artikuls?artikuls_id_in=${articleId}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.filter(item => Object.keys(item).length !== 0).map(item => (
            {
              id: item['ID'],
              code: item['PRODUCT_CODE'],
              text: item['PRODUCT_NAME'],
              name: item['ORDER_NUM'],
              checked: item['CHBOX'] === 1
            }
          ));
        }
      )
    );
  }

  saveCopyArticles(articleId: string, attributesStr: string, articlesStr: string): Observable<IServiceResponse> {
    const header = {
      operationURL: `ARTUCUL_PACK.copy_artikuls?from_artikul_id_in=${articleId}&fields_array_in=${attributesStr}&artikuls_array_in=${articlesStr}&lang_in=rdf`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }


  ////////////////////////////////////////////////////
  // ЗАКРЫТИЕ АРТИКУЛОВ
  ////////////////////////////////////////////////////

  /**
   * Получить шапку артикулов для закрытия артикулов процесса
   * @param processId
   */
  getCloseHeadArticles(processId: string): Observable<IWorkflowCloseHeadArticles> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_close_artikuls_head?process_id_in=${processId}`).pipe(
      map(
        result => {
          console.log(result);
          return this.mapCloseHeadArticlesFromService(result[0]);
        }
      )
    );
  }


  /**
   * Получить список артикулов для закрытия артикулов процесса
   * @param processId
   */
  getCloseArticles(processId: string): Observable<Array<IWorkflowCloseArticle>> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_artikuls?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result.map(item => this.mapCloseArticleFromService(item));
        }
      )
    );
  }

  // Сохранить шапку при закрытии артикулов
  putCloseHeadArticles(headArticles: IWorkflowCloseHeadArticles,
                       hyperListStr: string = '',
                       cityListStr: string = '',
                       rainbowListStr: string = '',
                       atakListStr: string = '',
                       supplierListStr: string = '',
                       reasonList: IWorkflowCloseReasons = {...emptyWorkflowCloseReasons}
  ): Observable<IServiceResponse> {
    const param = {};
    const body = this.mapCloseHeadToService(headArticles, hyperListStr, cityListStr, rainbowListStr, atakListStr, supplierListStr, reasonList);

    console.log(body);

    return this.putWorkflowData(`ARTIKULS_CLOSE_PKG.UPD_ARTIKULS_CLOSE`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );

    // return of({...emptyServiceResponse});

  }

  mapCloseHeadToService(item: any,
                        hyperListStr: string = '',
                        cityListStr: string = '',
                        rainbowListStr: string = '',
                        atakListStr: string = '',
                        supplierListStr: string = '',
                        reasonList: IWorkflowCloseReasons = {...emptyWorkflowCloseReasons}
                        ): object {

    const result = {

      process_id_in: item.processInstanceId,
      SEC_IN: item.sec,
      RAY_IN: item.ray,
      ART_STATUS_IN: encodeURIComponent(item.articleStatus),

      HYPERMARKET_IN: hyperListStr,
      CITY_IN: cityListStr,
      RAWNBOW_IN: rainbowListStr,
      ATAK_IN: atakListStr,
      SUPPLIER_CODES_IN: supplierListStr,
      REASON_IN:  this.mapCloseReasonsToString(reasonList),

      ADDITION_IN: item.addition,
      NAZLEVEL_IN: item.nazlevel,
      OPE_IN: item.ope,
      ALL_SUP_IN: item.allSupplier ? "1" : "0", //item.allSupplier,
      MAIN_SUP_IN: item.mainSupplier,
      PS_DATE_START_IN: item.psDateStart,
      ACTIVE_STATUS_DATE_IN: item.activeStatusDate,

    };

    return result;
  }


  /**
   * Получить список магазинов для закрытия артикулов процесса
   * @param processId
   * @param grappaId
   */
  getCloseGrappa(processId: string, grappaId: string): Observable<Array<IWorkflowCloseGrappaItem>> {
    //BIS_TYPE_IN (1-HYPER, 2-CITY,  3-RAWNBOW, 4- ATAK)
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_grapps?process_id_in=${processId}&bis_type_in=${grappaId}`).pipe(
      map(
        result => {
          return result.map(item => this.mapCloseGrappaItemFromService(item));
        }
      )
    );
  }


  /**
   * Получить список поставщиков для закрытия артикулов процесса
   * @param processId
   */
  getCloseSuppliers(processId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_SUPPLIERS?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result.map(item => ({code: item['code'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }

  /**
   * Получить список поставщиков для закрытия артикулов процесса
   * @param processId
   */
  getCloseSuppliersSegments(processId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.GetSegmentSuppliers?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result.map(item => ({code: item['SUPPLIER_CODE'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }

  /**
   * Получить список причин для закрытия артикулов процесса
   * @param processId
   */
  getCloseReasons(processId: string): Observable<IWorkflowCloseReasons> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_reason?process_id_in=${processId}`).pipe(
      map(
        result => {
          return this.mapCloseReasonsFromService(result[0]);
        }
      )
    );
  }

  // Операции с закрываемыми артикулами // 1 add, 2 del, 3 update
  editCloseArticle(processId: string, articleCode: string, operationId: string, comment: string, articleReplaceCode: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.oper_artikul?process_id_in=${processId}&art_id_in=${articleCode}&oper_in=${operationId}&COMMENT_TXT_IN=${comment}&replace_id_in=${articleReplaceCode}`).pipe(
      map(
        result => {
          return result[0];
        }
      )
    );
  }

  // Операции с поставщиками для закрываемых артикулов // 1 add,2 delete,3 edit,4 add all
  editCloseSupplier(processId: string, supplierCode: string, operationId: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.oper_supplier?process_id_in=${processId}&sup_id_in=${supplierCode}&oper_in=${operationId}`).pipe(
      map(
        result => {
          return result[0];
        }
      )
    );
  }

  // Изменить статус причину с вводом решений закупщика и кодификации для артикула
  setCloseReasonReject(articleId: string, rejectBCode: string, rejectBNote: string, rejectCodifCode: string, rejectCodifNote: string, rejectCodifOne: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.edit_approve_reject?ID_IN=${articleId}&REJECT_B_IN=${rejectBCode}&REJECT_B_NOTE_IN=${rejectBNote}&REJECT_CODIF_IN=${rejectCodifCode}&REJECT_CODIF_NOTE_IN=${rejectCodifNote}&REJECT_CODIF_ONE_IN=${rejectCodifOne}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }

  // Массовые операции кодификации при создании артикулов
  setCloseRejectCodifAll(processId: string, rejectCodifCode: string, rejectCodifNote: string, rejectCodifOne: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.edit_all_approve_reject?process_id_in=${processId}&REJECT_CODIF_IN=${rejectCodifCode}&REJECT_CODIF_NOTE_IN=${rejectCodifNote}&REJECT_CODIF_ONE_IN=${rejectCodifOne}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );

  }


  /**
   * Создать вкладку закрытия артикулов для создания и реактивации
   * @param processId
   */
  createCloseProcess(processId: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.CreateClose?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }

  /**
   * Удалить вкладку закрытия артикулов для создания и реактивации
   * @param processId
   */
  deleteCloseProcess(processId: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.DeleteClose?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }

  /**
   * Проверить наличие вкладки закрытия артикулов для создания и реактивации
   * @param processId
   */
  checkCloseProcess(processId: string): Observable<any> {
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.is_close_visilbe?process_id_in=${processId}`).pipe(
      map(
        result => {
          return result;
        }
      )
    );
  }



  ///////////////////////////////////////
  // Реактивация артикулов
  ///////////////////////////////////////
  /**
   * Получить список артикулов для шапки и установленных фильтровв
   * @param headArticlesId
   * @param partEnterStr
   * @param statusArticlesStr
   * @param codeAssortmentStr
   * @param isCreatedForMoscow
   */
  getReactivateArticlesFilterList(headArticlesId: string,
                        partEnterStr: string,
                        statusArticlesStr: string,
                        codeAssortmentStr: string,
                        isCreatedForMoscow: string
  ): Observable<Array<IWorkflowArticleItem>> {
    return this.getWorkflowData(`MODIFY_ART.get_reakt_artikuls?ARTIKULS_HEAD_ID_IN=${headArticlesId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`).pipe(
      map(
        result => {
          return result.map(item => this.mapArticleItemFromService(item));
        }
      )
    );
  }


  /**
   * Получить шапку артикулов для реактивации артикулов процесса
   * @param processId
   */
  getReativateHeadArticles(processId: string): Observable<IWorkflowReactivateHeadArticles> {
    return this.getWorkflowData(`MODIFY_ART.get_reskt_head?PROCESSID_IN=${processId}`).pipe(
      map(
        result => {
          return this.mapReactivateHeadArticlesFromService(result[0]);
        }
      )
    );
  }

  mapReactivateHeadArticlesFromService(item):IWorkflowReactivateHeadArticles {
    return {...emptyWorkflowReactivateHeadArticles,
      activeEnd1: item['ACTIVE_END1'] ? moment(item['ACTIVE_END1'], 'DD.MM.YYYY').toDate() : null,
      activeEnd2: item['ACTIVE_END2'] ? moment(item['ACTIVE_END2'], 'DD.MM.YYYY').toDate() : null,
      activeEnd3: item['ACTIVE_END3'] ? moment(item['ACTIVE_END3'], 'DD.MM.YYYY').toDate() : null,
      activeEnd4: item['ACTIVE_END4'] ? moment(item['ACTIVE_END4'], 'DD.MM.YYYY').toDate() : null,
      activeStart1: item['ACTIVE_START1'] ? moment(item['ACTIVE_START1'], 'DD.MM.YYYY').toDate() : null,
      activeStart2: item['ACTIVE_START2'] ? moment(item['ACTIVE_START2'], 'DD.MM.YYYY').toDate() : null,
      activeStart3: item['ACTIVE_START3'] ? moment(item['ACTIVE_START3'], 'DD.MM.YYYY').toDate() : null,
      activeStart4: item['ACTIVE_START4'] ? moment(item['ACTIVE_START4'], 'DD.MM.YYYY').toDate() : null,
      articleComment: item['ART_COMMENT'],
      articleReasonCode: item['ART_REASUN_CODE'],
      atak: item['ATAK'],
      changeSupplierComment: item['CHANGE_COMMENT'],
      changeSupplierReasonCode: item['CHANGE_REASUN_CODE'],
      changeSupplierReactivation: item['CH_SUPL_REAKT'],
      city: item['CITY'],
      closeOldSupplierNationalLevel: item['CLOSE_OLD_SUP_NAZ_LVL'] === "1",
      hypermarket: item['HYPERMARKET'],
      id: item['ID'],
      isChangeSupplier: item['IS_CHANGE_SUP'] === "1",
      isReactivation: item['IS_REAKT'] === "1",
      newArticleStatus: item['NEW_ART_STAT'],
      oldSupplier: item['OLD_SUP'],
      oldSupplierStatus: item['OLD_SUP_STAT'],
      processId: item['PROCESSID'],
      rainbow: item['RAWNBOW'],
      regStatusNationalLevel: item['REG_STATUS_NAZ_LVL'],
      closeOldSupplierSupplierNewNum: item['SUPPPLIER_NEW_NUM'] === "1",
    };
  }


  // Сохранить шапку при реактивации артикулов
  putReactivateHeadArticles(headArticles: IWorkflowReactivateHeadArticles,
                       hyperListStr: string = '',
                       cityListStr: string = '',
                       rainbowListStr: string = '',
                       atakListStr: string = ''
  ): Observable<IServiceResponse> {
    const param = {};
    const body = this.mapReactivateHeadToService(headArticles, hyperListStr, cityListStr, rainbowListStr, atakListStr);

    console.log(body);

    return this.putWorkflowData(`MODIFY_ART.oper_reskt_head`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  mapReactivateHeadToService(item: any,
                        hyperListStr: string = '',
                        cityListStr: string = '',
                        rainbowListStr: string = '',
                        atakListStr: string = ''
  ): object {

    let changeSupplierReactivation = '';
    const reactivationReasonComment = item.isReactivation ? item.articleReasonCode + '#' + item.articleComment : '';
    const supplierReasonComment = item.isChangeSupplier ? item.changeSupplierReasonCode + '#' + item.changeSupplierComment : '';

    if (item.isChangeSupplier) changeSupplierReactivation = '1';
    if (item.isReactivation) changeSupplierReactivation += '2';

    const result = {

      id_in: item.id,
      oper_in: '0', //не используется
      PROCESSID_IN: item.processId,
      change_supl_reakt_in: changeSupplierReactivation,
      HYPERMARKET_IN: hyperListStr,
      CITY_IN: cityListStr,
      RAWNBOW_IN: rainbowListStr,
      ATAK_IN: atakListStr,
      old_sup_code_in: item.oldSupplier,
      old_sup_status_in: item.oldSupplierStatus,
      sup_new_num_in: item.closeOldSupplierSupplierNewNum ? "1" : "0",
      close_old_sup_naz_in: item.closeOldSupplierNationalLevel ? "1" : "0",
      reg_status_naz_level_in: item.regStatusNationalLevel,
      new_art_status_in: item.newArticleStatus,
      reakt_comment_in: encodeURIComponent(reactivationReasonComment),
      ACTIVE_START1_IN: item.activeStart1 ? moment(item.activeStart1).format('DD.MM.YYYY') : '',
      ACTIVE_END1_IN: item.activeEnd1 ? moment(item.activeEnd1).format('DD.MM.YYYY') : '',
      ACTIVE_START2_IN: item.activeStart2 ? moment(item.activeStart2).format('DD.MM.YYYY') : '',
      ACTIVE_END2_IN: item.activeEnd2 ? moment(item.activeEnd2).format('DD.MM.YYYY') : '',
      ACTIVE_START3_IN: item.activeStart3 ? moment(item.activeStart3).format('DD.MM.YYYY') : '',
      ACTIVE_END3_IN: item.activeEnd3 ? moment(item.activeEnd3).format('DD.MM.YYYY') : '',
      ACTIVE_START4_IN: item.activeStart4 ? moment(item.activeStart4).format('DD.MM.YYYY') : '',
      ACTIVE_END4_IN: item.activeEnd4 ? moment(item.activeEnd4).format('DD.MM.YYYY') : '',
      change_comment_in: encodeURIComponent(supplierReasonComment),

    };

    return result;
  }

  // Операции с закрываемыми артикулами // 1 add, 2 del, 3 update
  addReactivateArticle(headArticleId: string, articleCode: string): Observable<any> {
    return this.getWorkflowData(`MODIFY_ART.add_reakt_artikul?artikul_code_in=${articleCode}&ARTIKULS_HEAD_ID_IN=${headArticleId}`).pipe(
      map(
        result => {
          return result[0];
        }
      )
    );
  }

  getModifyGrappa(processId: string, grappaId: string): Observable<Array<IWorkflowCloseGrappaItem>> {
    //BIS_TYPE_IN (1-HYPER, 2-CITY,  3-RAWNBOW, 4- ATAK)
    return this.getWorkflowData(`MODIFY_ART.get_modif_grapps?process_id_in=${processId}&bis_type_in=${grappaId}`).pipe(
      map(
        result => {
          return result.map(item => this.mapCloseGrappaItemFromService(item));
        }
      )
    );
  }

  getAllGrappa():Observable<Array<any>> {

    return this.getWorkflowData('get_all_grappa').pipe(
      map(result => {
        return result.map(item => ({code: item['code'], name: item['grappa_name']}));
      })
    );


  }

  /**
   * Получить список поставщиков для реактивайии артикулов процесса
   * @param processId
   */
  getModifySuppliersSegments(processId: string): Observable<Array<any>> {
    return this.getWorkflowData(`MODIFY_ART.get_segment_suppliers?PROCESSID_IN=${processId}`).pipe(
      map(
        result => {
          return result.map(item => ({code: item['SUP_CODE'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }


  /*
  getModifyArticleGrappaPrices(articleId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_artikul_priceses?artikuls_id_in=${articleId}`).pipe(
      map(
        result => {
          return result.map (data => (
            {
              num: data['grappa'],
              id: data['id'],
              articleId: data['artikuls_id'],
              grappaCode: data['grappa'],
              grappaName: data['grappa_name'],
              price: data['price'],
              infl: data['infl']

            }
          )); //this.mapCloseArticleFromService(item));
        }
      )
    );
  }
  */

  getReactivateArticleGrappaPrices(articleId: string, articleCode: string, supplierCode: string): Observable<Array<any>> {
    return this.getWorkflowData(`MODIFY_ART.get_reakt_artikul_priceses?artikuls_id_in=${articleId}&art_code_in=${articleCode}&sup_code_in=${supplierCode}`).pipe(
      map(
        result => {
          return result.map (data => (
            {
              num: data['grappa'],
              id: data['id'],
              articleId: data['artikuls_id'],
              grappaCode: data['grappa'],
              grappaName: data['grappa_name'],
              price: data['price'],
              priceOld: data['price_old'],
              infl: data['infl']

            }
          ));
        }
      )
    );
  }


  // Операции с ценами при создании/реактивации артикулов
  putGrappaPrices(id: string, articleId: string, grappaId: string, price: string, priceNew: string, operation: string
  ): Observable<IServiceResponse> {
    const param = {};
    const body = {
      "id_in": id,
      "artikuls_id_in": articleId,
      "grappa_in": grappaId,
      "price_in": encodeURIComponent(price),
      "price_new_in": encodeURIComponent(priceNew),
      "oper_in": operation
    };

    console.log(body);

    return this.putWorkflowData(`ARTUCUL_PACK.oper_artikul_price`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }



  /////////////////////////////////////
  /////// Валидация прайслистов ///////
  /////////////////////////////////////

  /**
   * Получить список артикулов прайслиста
   * @param processId
   * @param grappa
   * @param articleStatus
   */
  getPricelistArticles(processId: string, grappa: string = '', articleStatus: string = ''): Observable<Array<IWorkflowPricelistArticle>> {
    return this.getWorkflowData(`tarif_pack.get_pricelist_artikuls?PROCESS_IN=${processId}&GRAPPA_IN=${grappa}&status_in=${articleStatus}`).pipe(
      map(
        result => {
          console.log(result);
          return (result[0]['PLData'] ? result[0]['PLData']['rowitemPL'].length > 0 ? result[0]['PLData']['rowitemPL'] : Array(result[0]['PLData']['rowitemPL']) : [])
            .map(item => this.mapPricelistArticleFromService(item));
        }
      )
    );
  }

  putPricelistArticle(articleItem: IWorkflowArticleStrItem, typeOperation = '1'): Observable<IServiceResponse> { //IWorkflowPricelistArticle
    const param = {};
    const body = this.mapPricelistArticleItemToService(articleItem, typeOperation);

    console.log(JSON.stringify(body));

    return this.putWorkflowData(`tarif_pack.add_pricelist_artikuls`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  mapPricelistArticleItemToService(itemArticle: IWorkflowArticleStrItem, typeOperation): object {

    const item = itemArticle.priceInfo;

    const result = {
      add_del_edit: typeOperation,
      ID_IN: item.id,
      process_id_in: item.processId,
      GRAPPA_IN: item.grappa,
      CODE_IN: itemArticle.artCodeNew, // item.code,
      BARCODE_IN: item.barcode,
      NDS_RATE_IN: item.ndsRate,
      DATE_TARIF_IN: item.dateTarif,
      QBOX_IN: item.quanInBox,
      NAME_IN: encodeURIComponent(itemArticle.productName), //item.name,
      FROM_COUNTRY_IN: item.fromCountry,
      PRODUCT_SHELF_LIFE_IN: item.productShelfLife,
      CUR_PRICE_IN: item.currentPrice,
      CUR_DISC_IN: item.currentDiscount,
      CUR_TOTAL_IN: item.currentTotalPrice,
      CALC_PRICE_IN: item.calcPrice,
      CALC_TOTAL_IN: item.calcTotalPrice,
      CALC_PROC_UP_IN: item.calcPercentUp,
      SEL_CASE_IN: item.selectedCase,
      SEL_PRICE_IN: item.selectedPrice,
      SEL_TOTAL_IN: item.selectedTotalPrice,
      SEL_DICS_IN: item.selectedDiscount,
      SEL_PROC_UP_IN: item.selectedPercentUp,
      STATUS_IN: item.status,
      check_comment_in: encodeURIComponent(item.checkComment)
    }
    return result;
  }

  //список грапп
  getPricelistGrappa(processId: string = ''): Observable<Array<any>> {
    return this.getWorkflowData(`tarif_pack.get_process_grappa?process_id_in=${processId}`).pipe(
      map(result => {
          //console.log(result);
          return result.map(item => ({code: item['code'], name: `${item['code']} ${item['grappa_name']}`}));
        }
      )
    );
  }


  putPricelistArticles(operation: string,
                       id: string,
                       processId: string,
                       grappaCode: string,
                       kuPrice: string,
                       kuDiscount: string,
                       buyerPrice: string,
                       buyerDiscount: string,
                       selectedDecision: string

  ): Observable<IServiceResponse> {
    const param = {};
    const body = {
      "oper_in": operation,
      "id_in": id,
      "PROCESS_IN": processId,
      "GRAPPA_IN": grappaCode,
      "KU_PRICE_IN": kuPrice,
      "KU_DISC_IN": kuDiscount,
      "B_PRICE_IN": buyerPrice,
      "B_DISC_IN": buyerDiscount,
      "SEL_CASE_IN": selectedDecision
    };

    console.log(body);

    return this.putWorkflowData(`tarif_pack.oper_pricelist_artikuls`, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  getPricelistNationalGrappa(processId: string, modeId: string): Observable<any> {

    return this.getWorkflowData(`tarif_pack.create_nazgrappa_art?process_id_in=${processId}&mode_in=${modeId}`).pipe(
      map(result => {
          //console.log(result);
          return result; //.map(item => ({code: item['code'], name: item['grappa_name']}));
        }
      )
    );
  }


  checkPricelistArticles(processId: string, modeId: string): Observable<any> {

    return this.getWorkflowData(`tarif_pack.set_check_process_art?process_id_in=${processId}&mode_in=${modeId}`).pipe(
      map(result => {
          //console.log(result);
          return result; //.map(item => ({code: item['code'], name: item['grappa_name']}));
        }
      )
    );
  }



  /////////////////////////////////////////
  /////////////// Analytics /////////////
  ///////////////////////////////

  getAnalyticsArticles(processId: string,
               level: string = '',
               grappa: string = '',
               businessType: string = '',
               type: string = '',
               isHide: string = ''): Observable<Array<IWorkflowAnalyticsArticleItem>> {

    //"process_id_in","level_in","grappa_in","BUSINESS_TYPE_IN","TYPE_IN","hide_in"
    return this.getWorkflowData(`ARTUCUL_PACK.get_DM_ASRT?process_id_in=${processId}&level_in=${level}&grappa_in=${grappa}&BUSINESS_TYPE_IN=${businessType}&TYPE_IN=${type}&hide_in=${isHide}`).pipe(
      map(
        result => {
          //console.log(result);
          return result.map(item => this.mapAnalyticsArticleItemFromService(item));
        }
      )
    );
  }

  //список грапп
  getAnalyticsGrappa(processId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ARTUCUL_PACK.get_analit_grappa?process_id_in=${processId}`).pipe(
      map(result => {
          return result.map(item => ({code: item['code'], name: item['grappa_name']}));
        }
      )
    );
  }


  getReportAnalyticsArticleExcel(processId: string,
                                 level: string = '',
                                 grappa: string = '',
                                 businessType: string = '',
                                 type: string = '',
                                 isHide: string = '',
                                 filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=DM_ASRT.rptdesign&process_id_in=${processId}&level_in=${level}&grappa_in=${grappa}&BUSINESS_TYPE_IN=${businessType}&TYPE_IN=${type}&hide_in=${isHide}&__format=xls`,
      filename: filename
    };

    /*
    ServerUrl + "/birt/frameset?__report=DM_ASRT.rptdesign&"
					+	"&process_id_in=" + process_id	+ "&level_in="+ Nom_combo.selectedItem.PT_ID
					+"&grappa_in=" + grapap_combo.selectedItem.code
					+ "&BUSINESS_TYPE_IN=" + biz_combo.selectedItem.PT_ID
					+ "&TYPE_IN=" + Nom_combo0.selectedItem.PT_ID
					+ 	"&hide_in=" + hide_in
					+ "&__format=xls"	);

     */

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }




  ////////////////////////////////
  ////// Analytics tariff ////////
  ////////////////////////////////

  //список грапп
  getAnalyticsTariffGrappa(processId: string ): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_process_grappa?process_id_in=${processId}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['GRAPPA_CODE'], name: item['GRAPPA_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffInflationCommon(processId: string,
                                     grappa: string
  ): Observable<Array<IWorkflowAnalyticsInflCommonItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_inflation?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffInflCommonItemFromService(item));
        }
      )
    );
  }

  getAnalyticsTariffInflationFamily(processId: string,
                                         grappa: string,
                                         inflView: string = '',
                                         mode: string = ''
  ): Observable<Array<IWorkflowAnalyticsInflFamilyItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_inf_chart?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&infl_view_id=${inflView}&mode_in=${mode}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffInflFamilyItemFromService(item));
        }
      )
    );
  }


  getAnalyticsTariffInflationArticle(processId: string,
                                     grappa: string
                      ): Observable<Array<IWorkflowAnalyticsInflArticleItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_inflation_art_seg?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}`).pipe(
      map(
        result => {
          console.log(result);
          return result.map(item => this.mapAnalyticsTariffInflArticleItemFromService(item));
        }
      )
    );
  }


  //список грапп для истории тарифов
  getAnalyticsTariffHistoryGrappa(processId: string): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_process_grappa_hist?process_id_in=${processId}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['GRAPPA_CODE'], name: item['GRAPPA_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffHistoryCategory(processId: string, grappa: string): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_process_cat?process_id_in=${processId}&GRAPPA_CODE_IN=${grappa}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['CATEG_ID'], name: item['CATEG_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffHistoryFamily(processId: string, grappa: string, category: string): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_process_fam?process_id_in=${processId}&GRAPPA_CODE_IN=${grappa}&cat_in=${category}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['fam'], name: item['fam_name']}));
        }
      )
    );
  }

  getAnalyticsTariffHistorySupplier(processId: string, grappa: string, family: string, noZero: string): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_art_history_sup?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&FAMILY_ID_in=${family}&nozero=${noZero}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['SUPPLIER_ID'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffHistorySupplierStacked(processId: string, grappa: string, category: string, family: string, upDown: string
  ): Observable<Array<any>> {

    return this.getWorkflowData(`ANALIT_PACK.get_art_hist_stacked_sup?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&CATEGORY_ID_IN=${category}&FAMILY_ID_in=${family}&updown_in=${upDown}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['SUPPLIER_ID'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffHistoryArticleSupplier(processId: string, grappa: string, family: string): Observable<Array<any>> {
    return this.getWorkflowData(`ANALIT_PACK.get_art_history_sup2?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&FAMILY_ID_in=${family}`).pipe(
      map(result => {
          console.log(result);
          return result.map(item => ({code: item['SUPPLIER_ID'], name: item['SUPPLIER_NAME']}));
        }
      )
    );
  }

  getAnalyticsTariffHistoryFamilyChart(processId: string, grappa: string, family: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffChartItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_art_history_xml_rdf?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&FAMILY_ID_in=${family}`).pipe(
      map(
        result => {
          console.log(result);
          return result[0]['myTarifData']['rowitem'].map(item => this.mapAnalyticsTariffHistoryChartItemFromService(item));
        }
      )
    );
  }

  getAnalyticsTariffHistoryFamilyGrid(processId: string, grappa: string, family: string, noZero: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffGridItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_art_history_grid?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&FAMILY_ID_in=${family}&nozero=${noZero}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffHistoryGridItemFromService(item));
        }
      )
    );
  }


  getAnalyticsTariffHistoryStackedChart(processId: string, grappa: string, category: string, family: string, upDown: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffChartItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_art_hist_stacked_xml_rdf?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&CATEGORY_ID_IN=${category}&FAMILY_ID_in=${family}&updown_in=${upDown}`).pipe(
      map(
        result => {
          console.log(result);
          return result[0]['myTarifStackedData']['rowitem'].map(item => this.mapAnalyticsTariffHistoryStackedItemFromService(item));
        }
      )
    );
  }

  getAnalyticsTariffHistoryStackedGrid(processId: string, grappa: string, category: string, family: string, upDown: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffGridItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_art_hist_stacked_sup?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&CATEGORY_ID_IN=${category}&FAMILY_ID_in=${family}&updown_in=${upDown}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffHistoryGridItemFromService(item));
        }
      )
    );
  }

  getAnalyticsTariffHistoryArticle(processId: string,
                                  grappa: string,
                                  family: string,
                                   supplier: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffArticleItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_tarif_hist_art?PROCESS_INSTANCE_ID_IN=${processId}&GRAPPA_CODE_IN=${grappa}&FAMILY_IN=${family}&SUP_ID_IN=${supplier}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffHistoryArticleItemFromService(item));
        }
      )
    );
  }

  getAnalyticsTariffHistoryArticleHistory(processId: string,
                                          grappa: string,
                                          articlesStr: string,
                                          supplier: string
  ): Observable<Array<IWorkflowAnalyticsHistoryTariffArticleHistoryItem>> {

    return this.getWorkflowData(`ANALIT_PACK.get_tarif_hist_art_prices?PROCESS_INSTANCE_ID_IN=${processId}&ARTIKUL_ID_ARRAY_IN=${articlesStr}&SUPPLIER_ID_IN=${supplier}&GRAPPA_CODE_IN=${grappa}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => this.mapAnalyticsTariffHistoryArticleHistoryItemFromService(item));
        }
      )
    );
  }




  getReportAnalyticsTariffExcel(params: string = '',
                                reportName: string = '',
                                filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=${reportName}.rptdesign&${params}&__format=xls`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  mapAnalyticsTariffInflCommonItemFromService(item): IWorkflowAnalyticsInflCommonItem {

    return {
      ...emptyWorkflowAnalyticsInflCommonItem,
      articleId: item['ARTICLE_ID'],
      articleName: item['ARTICLE_NAME'],
      avgArticleMargin: item['AVG_ARTICLE_MARGIN'],
      id: item['ID'],
      segmentName: item['SEGMENT_NAME'],
      segmentToPrc: item['SEGMENT_TO_PRC'],
      supplierToPrc: item['SUPPLIER_TO_PRC'],
      tarifHistDate1: item['TARIF_HIST_DATE_1'],
      tarifHistDate2: item['TARIF_HIST_DATE_2'],
      tarifHistDate3: item['TARIF_HIST_DATE_3'],
      tarifHistValue1: item['TARIF_HIST_VALUE_1'],
      tarifHistValue2: item['TARIF_HIST_VALUE_2'],
      tarifHistValue3: item['TARIF_HIST_VALUE_3'],
      topSupplier1WavgInfl12m: item['TOP_SUPPLIER1_WAVG_INFL_12M'],
      topSupplier1WavgInflYear: item['TOP_SUPPLIER1_WAVG_INFL_YEAR'],
      topSupplier2WavgInfl12m: item['TOP_SUPPLIER2_WAVG_INFL_12M'],
      topSupplier2WavgInflYear: item['TOP_SUPPLIER2_WAVG_INFL_YEAR'],
      wavgInflFamily12m: item['WAVG_INFL_FAMILY_12M'],
      wavgInflFamilyYear: item['WAVG_INFL_FAMILY_YEAR'],
      wavgInflSupplier12m: item['WAVG_INFL_SUPPLIER_12M'],
      wavgInflSupplierYear: item['WAVG_INFL_SUPPLIER_YEAR'],
      topSupplier1Name: item['top_supplier1_name'],
      topSupplier2Name: item['top_supplier2_name'],
    };

  }

  mapAnalyticsTariffInflFamilyItemFromService(item): IWorkflowAnalyticsInflFamilyItem {

    return {
      ...emptyWorkflowAnalyticsInflFamilyItem,
      month: item['MONTH'],
      sup1SumWa12m: item['sup1_sum_wa_12m'],
      sup1SumWaYearStart: item['sup1_sum_wa_ystart'],
      sup2SumWa12m: item['sup2_sum_wa_12m'],
      sup2SumWaYearStart: item['sup2_sum_wa_ystart'],
      sup3SumWa12m: item['sup3_sum_wa_12m'],
      sup3SumWaYearStart: item['sup3_sum_wa_ystart'],
      topSupplier1Name: item['top_supplier1_name'],
      topSupplier2Name: item['top_supplier2_name'],
      totalSumWa12m: item['total_sum_wa_12m'],
      totalSumWaYearStart: item['total_sum_wa_ystart'],

      valuesYear: [
        item['total_sum_wa_ystart'],
        item['sup1_sum_wa_ystart'],
        item['sup2_sum_wa_ystart'],
        item['sup3_sum_wa_ystart']].map(value => Number(value) ? Number(value) : 0),
      values12m: [
        item['total_sum_wa_12m'],
        item['sup1_sum_wa_12m'],
        item['sup2_sum_wa_12m'],
        item['sup3_sum_wa_12m']].map(value => Number(value) ? Number(value) : 0),

    };

  }

  mapAnalyticsTariffInflArticleItemFromService(item): IWorkflowAnalyticsInflArticleItem {

    return {
      ...emptyWorkflowAnalyticsInflArticleItem,
      articleId: item['ARTICLE_ID'],
      articleName: item['ARTICLE_NAME'],
      grappaName: item['GRAPPA_NAME'],
      segmentId: item['segment_id'],
      wavgInflArticleSupl12m: item['wavg_infl_article_supl_12m'],
      wavgInflArticleSuplYear: item['wavg_infl_article_supl_year'],
      wavgInflSegment12m: item['wavg_infl_segment_12m'],
      wavgInflSegmentYear: item['wavg_infl_segment_year'],

    };

  }


  mapAnalyticsTariffHistoryGridItemFromService(item): IWorkflowAnalyticsHistoryTariffGridItem {

    const values = {};

    for (let key in item) {
      if (key.includes('MONTH')) {
        values[key.toLowerCase()] = item[key];
      }
    }

    return {
      ...emptyWorkflowAnalyticsHistoryTariffGridItem,
      supplier: item['SUPPLIER_ID'],
      supplierName: '(' + item['SUPPLIER_ID'] + ') ' + item['SUPPLIER_NAME'],
      values: values,
    };
  }

  mapAnalyticsTariffHistoryChartItemFromService(item): IWorkflowAnalyticsHistoryTariffChartItem {

    const values = {};

    for (let key in item) {
      if (key.includes('col')) {
        values[key.toLowerCase()] = item[key];
      }
    }

    return {
      ...emptyWorkflowAnalyticsHistoryTariffChartItem,
      month: item['MONTH_DECODE'].toString() + '0',
      values: values,
    };
  }

  mapAnalyticsTariffHistoryStackedItemFromService(item): IWorkflowAnalyticsHistoryTariffChartItem {

    const values = {};

    for (let key in item) {
      if (key.includes('col')) {
        values[key.toLowerCase()] = item[key];
      }
    }

    return {
      ...emptyWorkflowAnalyticsHistoryTariffChartItem,
      month: item['dt'].toString() + '0',
      values: values,
    };
  }

  mapAnalyticsTariffHistoryArticleItemFromService(item): IWorkflowAnalyticsHistoryTariffArticleItem {

    return {
      ...emptyWorkflowAnalyticsHistoryTariffArticleItem,
      articleId: item['ARTICLE_ID'],
      articleName: item['ARTICLE_NAME'],
      currentTariff: item['CURR_TARIF']
    };

  }

  mapAnalyticsTariffHistoryArticleHistoryItemFromService(item): IWorkflowAnalyticsHistoryTariffArticleHistoryItem {

    return {
      ...emptyWorkflowAnalyticsHistoryTariffArticleHistoryItem,
      articleIdHistory: item['ARTIKUL_ID'],
      articleNameHistory: item['ARTIKUL_NAME'],
      tariffDate: item['TARIF_DATE'],
      tariffValue: Number(item['TARIF_VALUE']) ? Number(item['TARIF_VALUE']) : 0
    };

  }



  ///////////////////////////////
  ////// Start process //////////
  ///////////////////////////////

  //Наименование поставщика по коду
  getSupplierName(supplierCode: string): Observable<Array<any>> {
    return this.getWorkflowData(`get_supplyer_name?supplyer_code_in=${supplierCode}`).pipe(
      map(result => {
          return result;
        }
      )
    );
  }

  //Полный список сегментов
  getSegmentList(): Observable<Array<any>> {
    return this.getWorkflowData(`get_segment?PARENT_CODE_IN=-`).pipe(
      map(result => {
          //console.log(result);
          return result.map(item => ({code: item['CODE'], name: '(' + item['CODE'] + ') ' + item['NAME']}));
        }
      )
    );
  }

  getBuyerCode(buyerName: string): Observable<Array<any>> {
    return this.getWorkflowData(`Get_buyer_fill_code?username_in=${buyerName}&process_id_in=0`).pipe(
      map(result => {
          return result;
        }
      )
    );
  }

  getParseArticleList(articleStr: string, segmentCode: string, supplierCode: string): Observable<Array<any>> {
    return this.getWorkflowData(`MODIFY_ART.parsing_art?articuls_in=${articleStr}&segment_in=${segmentCode}&supl_in=${supplierCode}`).pipe(
      map(result => {
          console.log(result);
          //return result;
          return result.map(item => (
              {
                family: item['NOMFAM_CODE'],
                code: item['code'],
                name: item['name'],
                num: item['rn']
              }
            )
          );
        }
      ));
  }


  //Карточка запуска процесса для артикулов
  getStartProcessReportCard(processType: string = '',
                            filename: string = "''",
                            supplierCode: string,
                            buyerCode: string,
                            reportType: string = '',
                            articleMode: string = '',
                            articleListStr: string = '',
                            statusListStr: string = '',
                            segmentCode: string = ''
  ): Observable<IWorkflowFile> {

    let service = '';

    switch (processType) {
      case 'CREATE':
      case 'ROTATE':
        service = `/rest/services/Creation_nomenclature_articles/getSupReport:1.0?supplyer_num_in=${supplierCode}&supplyer_name_in=&buyer_num_in=${buyerCode}`;
        break;
      case 'CLOSE':
        service = `/rest/services/Closure_nomenclature_articles/getCloseSupReport:1.0?supplyer_num_in=${supplierCode}&buyer_num_in=${buyerCode}`;
        break;
      case 'MODIFY':
      case 'REACTIVATE':
        //service = `/rest/services/StartProc/SupReportModifReakt:1.0?supplyer_num_in=${supplierCode}&buyer_num_in=${buyerCode}&report_type=${reportType}&art_mode=${articleMode}&art_list=${encodeURIComponent(articleListStr)}&status_list=${encodeURIComponent(statusListStr)}&ray_in=${segmentCode}`;
        service = `/rest/services/StartProc/SupReportModifReakt2:1.0?supplyer_num_in=${supplierCode}&buyer_num_in=${buyerCode}&report_type=${reportType}&art_mode=${articleMode}&${articleListStr ? 'art_list=' + encodeURIComponent(articleListStr) + '&' : ''}status_list=${encodeURIComponent(statusListStr)}&ray_in=${segmentCode}`;

    }

    const header = {
      fileUrl: service,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }



  putStartProcess(serviceName: string,
               modelBody: string
               /*
               supplierNum: string,
               supplierName: string,
               supplierEmail: string,
               dateIn: string,
               depName: string,
               otdelName: string,
               zakupchikName: string,
               managerNum: string,
               managerName: string,
               userId: string
               */)

    : Observable<IServiceResponse> {

    const param = {
      servicename: serviceName
    };

    /*
    const body =
      {
        "pricevalidmodel": {
          "PriceValidRow": {
            "PostavName": supplierName, //"(47) МИР БАКАЛЕИ ООО",
            "PostavNum": supplierNum, //"47",
            "PostavEmail": supplierEmail, //"iakiev90@gmail.com",
            "DateIn": dateIn, //"01.01.2020",
            "department": depName, //"test_dep",
            "OtdelCOZ": otdelName, //"test_otdel",
            "ManagerNum": managerNum, //"0001",
            "ManagerName": managerName, //"Buyer1_test Buyer1_test",
            "ZakupchikUser": zakupchikName, //"buyer1_test",
            "KUexpertUser": userId + ' ' + userId, //"Buyer1_test Buyer1_test",
            "KUexpertUsername": userId, //"buyer1_test",
            "SupName": supplierName //"(47) МИР БАКАЛЕИ ООО"
          }
        }
      };
*/

      return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/startProccess`, param, modelBody).pipe(
        map((result: IServiceResponse) => {
          return result;
        })
      );

  }



  mapAnalyticsArticleItemFromService(item): IWorkflowAnalyticsArticleItem {

    return {
      ...emptyWorkflowAnalyticsArticleItem,
      businessType: item['BUSINESS_TYPE'],
      nomenclature: item['CSFAAR'],
      type: item['CSTAAR'],
      grappa: item['GAPPCR'],
      confirmDiffRef: item['confirm_diff_ref'],
      confirmRef: item['confirm_ref'],
      diffRef: item['diff_ref'],
      factRef13: item['fact_ref_1_3'],
      factRef23: item['fact_ref_2_3'],
      factRef33: item['fact_ref_3_3'],
      factRefAll: item['fact_refall'],
      planRef13: item['plan_ref_1_3'],
      planRef23: item['plan_ref_2_3'],
      planRef33: item['plan_ref_3_3'],
      planRefAll: item['plan_refall'],
    };

  }



  mapPricelistArticleFromService(item): IWorkflowPricelistArticle {
    return {
      ...emptyWorkflowPricelistArticle,
      barcode: item['BARCODE'],
      buyerDiscount: item['B_DISC'],
      buyerPrice: item['B_PRICE'],
      buyerPercentUp: item['B_PROC_UP'],
      buyerTotalPrice: item['B_TOTAL'],
      calcPrice: item['CALC_PRICE'],
      calcPercentUp: item['CALC_PROC_UP'],
      calcTotalPrice: item['CALC_TOTAL'],
      chbox: item['CHBOX'],
      code: item['CODE'],
      currentDiscount: item['CUR_DISC'],
      currentPrice: item['CUR_PRICE'],
      currentTotalPrice: item['CUR_TOTAL'],
      dateTarif: item['DATE_TARIF'],
      fromCountry: item['FROM_COUNTRY'],
      fromCountrDecode: item['FROM_COUNTRY_DECODE'],
      grappa: item['GRAPPA'],
      id: item['ID'],
      kuDiscount: item['KU_DISC'],
      kuPrice: item['KU_PRICE'],
      kuPercentUp: item['KU_PROC_UP'],
      kuTotalPrice: item['KU_TOTAL'],
      name: item['NAME'],
      ndsRate: item['NDS_RATE'],
      processId: item['PROCESS_ID'],
      productShelfLife: item['PRODUCT_SHELF_LIFE'],
      quanInBox: item['QBOX'],
      selectedCase: item['SEL_CASE'],
      selectedCaseDecode: item['SEL_CASE_DECODE'],
      selectedDiscount: item['SEL_DICS'],
      selectedPrice: item['SEL_PRICE'],
      selectedPercentUp: item['SEL_PROC_UP'],
      selectedTotalPrice: item['SEL_TOTAL'],
      status: item['STATUS'],
      checkComment: item['CHECK_COMMENT']
    };
  }


  mapCloseHeadArticlesFromService(item): IWorkflowCloseHeadArticles {

    return {
      ...emptyWorkflowCloseHeadArticles,
      activeStatusDate: item['ACTIVE_STATUS_DATE'],
      addition: item['ADDITION'],
      allSupplier: item['ALL_SUP'] === '1',
      articleStatus: item['ART_STATUS'],
      fact: item['FACT'],
      filter: item['FILTER'],
      id: item['ID'],
      mainSupplier: item['MAIN_SUPPLIER'],
      mainSupplierName: item['MAIN_SUPPLIER_NAME'],
      nazlevel: item['NAZLEVEL'],
      ope: item['OPE'],
      plan: item['PLAN'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      psDateStart: item['PS_DATE_START'],
      ray: item['RAY'],
      raydsc: item['RAYDSC'],
      sec: item['SEC'],
      secdsc: item['SECDSC'],
      extra: item['extra'],
    };
  }


  mapCloseArticleFromService(item): IWorkflowCloseArticle {

    return {
      ...emptyWorkflowCloseArticle,
      artFakt: item['ARTFAKT'],
      artPlan: item['ARTPLAN'],
      artStatus: item['ARTSTATUS'],
      code: item['CODE'],
      codeReplace: item['CODE_REPLACE'],
      comment: item['COMMENT_TXT'],
      id: item['ID'],
      name: item['NAME'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      rejColor: item['REJCOLOR'],
      rejectBuyerCode: item['REJECT_B']?item['REJECT_B'].toString():'',
      rejectBuyerNote: item['REJECT_B_NOTE'],
      rejectBuyerDecode: item['REJECT_B_DECODE'],
      rejectCodifCode: item['REJECT_CODIF']?item['REJECT_CODIF'].toString():'',
      rejectCodifNote: item['REJECT_CODIF_NOTE'],
      rejectCodifDecode: item['REJECT_CODIF_DECODE'],
      dateInput: item['date_input'],
    };
  }

  mapCloseReasonsFromService(item): IWorkflowCloseReasons {

    return {
      ...emptyWorkflowCloseReasons,
      val1: item['val1'] === 1,
      val2: item['val2'] === 1,
      val3: item['val3'] === 1,
      val4: item['val4'] === 1,
      val5: item['val5'] === 1,
      val6: item['val6'] === 1,
      val7: item['val7'] === 1,
    };
  }

  mapCloseReasonsToString(closeReasons: IWorkflowCloseReasons): string {

    let result = '';

    if (closeReasons.val1) result += '1,';
    if (closeReasons.val2) result += '2,';
    if (closeReasons.val3) result += '3,';
    if (closeReasons.val4) result += '4,';
    if (closeReasons.val5) result += '5,';
    if (closeReasons.val6) result += '6,';
    if (closeReasons.val7) result += '7,';

    result = result.slice(0, -1);

    return result;

  }

  mapCloseGrappaItemFromService(item): IWorkflowCloseGrappaItem {

    return {
      ...emptyWorkflowCloseGrappaItem,
      code: item['GRAPPA_CODE'],
      name: item['GRAPPA_NAME'],
      bisType: item['BIS_TYPE'],
      isSelected: item['ISCHECKED'] === '1',
    };
  }




  /** Отчет Аудит процессов
   * @param processType
   * @param department
   * @param sector
   * @param currentUser
   * @param startDateFrom
   * @param startDateTo
   * @param filter
   * @param status
   */
  getReportAuditProcesses(processType: string,
                          department: string,
                          sector: string,
                          currentUser: string,
                          startDateFrom: string,
                          startDateTo: string,
                          filter: string,
                          status: string,
                          dateFrom: string = '',
                          dateUntil: string = '',
                          limit: number = 100,
                          offset: number = 0
  ): Observable<Array<IWorkflowProcess>> {
    if (this.isLikeAuchanMode()) {
      //return this.getWorkflowData(`audit_pack.get_audit?proctype_in=${processType}&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}`).pipe(
      return this.getWorkflowData(`audit_pack.get_audit?proctype_in=${processType}&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}&offset=${offset}&limit=${limit}`).pipe(

        map(
          result => {
            return result.map(item => mapAuchanAuditProcessesFromService(item));
          }
        )
      );
    } else {
      /*
      const param = {
        date_from: '20200101',
        date_until: '20201231'
      };*/
      return this.getProcesses(dateFrom, dateUntil);
    }

  }


  /** Отчет Аудит процессов - Список типов процессов
   */
  getReportAuditTypeProcesses(): Observable<Array<any>> {

    return this.getWorkflowData(`get_proc_types`).pipe(
      map(
        result => {
          console.log(result);
          return result.map(item => {
            return {code: item['proc_type_code'], name: item['proc_type_name']};
          });
        }
      )
    );
  }


  /** Отчет Аудит процессов - Список типов процессов
   * @param processType
   */
  getReportAuditStatusProcesses(processType: string): Observable<Array<any>> {

    return this.getWorkflowData(`audit_pack.get_proc_status_rdf?proctype_id_in=${processType}`).pipe(
      map(
        result => {
          console.log(result);
          return result.map(item => {
            return {code: item['id'], name: item['name']};
          });
          //return result.map(item => this.mapAuditProcessesFromService(item));
        }
      )
    );
  }

  /** Отчет Аудит процессов - Список типов отчетов
   * @param processId
   */
  getReportAuditTypeReports(processId: string): Observable<Array<any>> {

    return this.getWorkflowData(`audit_pack.get_process_reports?PROCESS_ID_IN=${processId}`).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.map(item => {
            return {code: item['id'], name: item['report_name'], description: item['URL']};
          });
        }
      )
    );
  }

  /** Отчет Аудит процессов
   * @param processType
   * @param currentUser
   * @param filter
   * @param limit
   * @param offset
   */
  getReportAuditTasks(processType: string,
                      currentUser: string,
                      filter: string = '',
                      limit: number = 100,
                      offset: number = 0
  ): Observable<Array<IWorkflowProcess>> {
    if (this.isLikeAuchanMode()) {
      return this.getWorkflowData(`audit_pack.get_audit2?proctype_in=${processType}&current_user_in=${currentUser}&filter=${filter}&offset=${offset}&limit=${limit}`).pipe(
        map(
          result => {
            console.log(result);
            return result.map(item => this.mapAuditTaskFromService(item));
          }
        )
      );
    }

  }



  mapAuditTaskFromService(item): IWorkflowProcess {
    return {
      ...emptyWorkflowProcess,
      userNameTaskAssigned: item['current_task_user'],
      dateArchive: item['date2arj'] ? moment(item['date2arj'], 'DD.MM.YYYY').toDate() : null,
      department: item['department'],
      isDelay: item['isdelay'] === "1",
      dateLastDecision: item['last_decis_date'] ? moment(item['last_decis_date'], 'DD.MM.YYYY').toDate() : null,
      lastDecision: item['last_decision'],
      statusCode: item['process_status'],
      statusName: item['process_status_decode'],
      requestSupplierName: item['request_supplier_name'],
      manager: item['manager'],
      id: item['processId'],
      name: item['processName'],
      sector: item['sector'],
      dateStart: item['startTime'] ? moment(item['startTime'], 'DD.MM.YYYY').toDate() : null,
      supplier: item['supplier'],
      whoDelay: item['who_delay'],
      bonusApproved: item['bonus_approved'],
      bonusCalculated: item['bonus_calculated'],

      taskId: item['task_id'],
      isEdit: item['is_edit'] === '1',

      limit: item['Limit'],
      offset: item['Offset'],
      next: item['Next'] && item['Next'] === 'true'

    };
  }


  /**
   * Получить отчет аудита список процессов в Excel
   * @param processType
   * @param department
   * @param sector
   * @param currentUser
   * @param startDateFrom
   * @param startDateTo
   * @param filter
   * @param status
   * @param filename
   */

  getReportAuditProcessesExcel(processType: string,
                               department: string,
                               sector: string,
                               currentUser: string,
                               startDateFrom: string,
                               startDateTo: string,
                               filter: string,
                               status: string,
                               filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=audit_common_rdf.rptdesign&proctype_in=${processType}&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}&__format=xls`,
      //fileUrl: `/birt/frameset?__report=audit_tariff_rdf.rptdesign&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}&__format=xls`,

      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  getReportAuditProcessesTariffExcel(processType: string,
                               department: string,
                               sector: string,
                               currentUser: string,
                               startDateFrom: string,
                               startDateTo: string,
                               filter: string,
                               status: string,
                               filename: string): Observable<IWorkflowFile> {

    const header = {
      //fileUrl: `/birt/frameset?__report=audit_common_rdf.rptdesign&proctype_in=${processType}&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}&__format=xls`,
      fileUrl: `/birt/frameset?__report=audit_tarif_rdf.rptdesign&otdel_in=${sector}&department_in=${department}&current_user_in=${currentUser}&startdatefrom=${startDateFrom}&startdateto=${startDateTo}&filter=${filter}&status=${status}&__format=xls`,

      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  /** Отчет Создание артикулов
   * @param dateFrom
   * @param dateTo
   * @param filter
   * @param onlyRotation
   */
  getArticlesCreationReport(dateFrom: string,
                            dateTo: string,
                            filter: string,
                            onlyRotation: string
  )
    : Observable<Array<IWorkflowArticleCreationReportItem>> {

    return this.getWorkflowData(`ARTUCUL_PACK.get_art_report_table?ItemInDateProc_from_IN=${dateFrom}&ItemInDateProc_to_IN=${dateTo}&RAY_IN=&POSTAVNUMPROC_IN=&POSTAVNUMPROC_IN=&POSTAVNAMEPROC_IN=&BARCODE_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&ManagerNameproc_IN=&RejectFilter_IN=1&PROC_TYPE_IN=1&rotation_only=${onlyRotation}&dep_in=&otd_in=&reason_in=&filter_in=${filter}`
    ).pipe(
      map(
        result => {
          return result.map(item => this.mapArticlesCreationReportFromService(item));
        }
      )
    );
  }

  mapArticlesCreationReportFromService(item): IWorkflowArticleCreationReportItem {
    return {
      ...emptyWorkflowArticleCreationReportItem,
      articleStatus: item['ARTICUL_STATUS'],
      articleCloseCode: item['ARTIKUL_CLOSE_CODE'],
      articleCodeNew: item['ART_CODE_NEW'],
      barcode: item['BARCODE'],
      buyerPrimechProc: item['BuyerPrimech_proc'],
      egais: item['EGAIS'],
      fromCountry: item['FROM_COUNTRY'],
      itemInDateProc: item['ITEMINDATEPROC'],
      itemSale: item['ITEMSALE'],
      itf14: item['ITF14'],
      lotOrder: item['LOTORDER'],
      managerNameProc: item['MANAGERNAMEPROC'],
      managerNumProc: item['MANAGERNUMPROC'],
      minPrice: item['MIN_PRICE'],
      supplierNameProc: item['POSTAVNAMEPROC'],
      supplierNumProc: item['POSTAVNUMPROC'],
      priceContract: item['PRICECONTRACT'],
      pricePerItem: item['PRICEPERITEM'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      productCode: item['PRODUCT_CODE'],
      productName: item['PRODUCT_NAME'],
      qInLote: item['Q_IN_LOTE'],
      ray: item['RAY'],
      reasonD: item['REASON_D'],
      reasonUnifiedD: item['REASON_UNIFIED_D'],
      rejColor: this.decodeRejColorCode(Number(item['REJCOLOR'])),
    };
  }



  decodeRejColorCode(rejColor: number): string {
    let rejColorCode: string;

    if (rejColor === 0) {
      rejColorCode = '#FFFFFF';
    } else if (rejColor === 1) {
      rejColorCode = '#000000';
    } else if (rejColor === 2) {
      rejColorCode = '#98d19e'; //#00FF00';
    } else if (rejColor === 3) {
      rejColorCode = '#FF0000';
    } else {
      rejColorCode = '#FFFFFF';
    }
    return rejColorCode;
  }

  getReportArticlesCreationExcel(dateFrom: string,
                                 dateTo: string,
                                 filter: string,
                                 onlyRotation: string,
                                 filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/proc_reports/report_create_table:1.0?filter_in=` + `${dateFrom},${dateTo},,,,,,,,1,,${onlyRotation},,,${filter}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  /** Отчет Закрытие артикулов
   * @param dateFrom
   * @param dateTo
   * @param filter
   * @param onlyRotation
   */
  getArticlesCloseReport(dateFrom: string,
                            dateTo: string,
                            filter: string,
                            onlyRotation: string
  )
    : Observable<Array<IWorkflowArticleCloseReportItem>> {

    //return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_art_clos_report_table?ItemInDateProc_from_IN=${dateFrom}&ItemInDateProc_to_IN=${dateTo}&RAY_IN=&POSTAVNUMPROC_IN=&POSTAVNAMEPROC_IN=&BARCODE_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&ManagerNameproc_IN=&RejectFilter_IN=1&PROC_TYPE_IN=1&rotation_only=${onlyRotation}&dep_in=&otd_in=&reason_in=&filter_in=${filter}`
    return this.getWorkflowData(`ARTIKULS_CLOSE_PKG.get_art_clos_report_table?ItemInDateProc_from_IN=${dateFrom}&ItemInDateProc_to_IN=${dateTo}&RAY_IN=&POSTAVNUMPROC_IN=&POSTAVNAMEPROC_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&ManagerNameproc_IN=&RejectFilter_IN=1&code_in=&rotation_only=${onlyRotation}&dep_in=&otd_in=&filter_in=${filter}`
  ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => this.mapArticlesCloseReportFromService(item));
        }
      )
    );
  }


  getReportArticlesCloseExcel(dateFrom: string,
                                 dateTo: string,
                                 filter: string,
                                 onlyRotation: string,
                                 filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/proc_reports/report_close_table:1.0?filter_in=` + `${dateFrom},${dateTo},,,,,,,,1,,${onlyRotation},,,0,0,${filter}`,
      //fileUrl: `/rest/services/proc_reports/report_close_table:1.0?filter_in=` + `${dateFrom},${dateTo},,,,,,,,1,,${onlyRotation},,,${filter}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  mapArticlesCloseReportFromService(item): IWorkflowArticleCloseReportItem {
    return {
      ...emptyWorkflowArticleCloseReportItem,
      codeReplace: item['CODE_REPLACE'],
      dateClose: item['Dateclose'],
      fact: item['FACT'],
      processDate: item['ITEMINDATEPROC'],
      managerNameProc: item['MANAGERNAMEPROC'],
      managerNumProc: item['MANAGERNUMPROC'],
      plan: item['PLAN'],
      supplierNameProc: item['POSTAVNAMEPROC'],
      supplierNumProc: item['POSTAVNUMPROC'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      productCode: item['PRODUCT_CODE'],
      productName: item['PRODUCT_NAME'],
      ray: item['RAY'],
      reasonDecode: item['REASON_DECODE'],
      //rejColor: item['REJCOLOR'],
      articleStatus: item['STATUS'],
      rejColor: this.decodeRejColorCode(Number(item['REJCOLOR'])),
    };
  }


  /** Отчет Модификация артикулов
   * @param dateFrom
   * @param dateTo
   * @param procType
   * @param filter
   */
  getArticlesModifyReport(dateFrom: string,
                         dateTo: string,
                         procType: string,
                         filter: string,
  )
    : Observable<Array<IWorkflowArticleModifyReportItem>> {

    return this.getWorkflowData(`MODIFY_ART.get_modif_report_table?ItemInDateProc_from_IN=${dateFrom}&ItemInDateProc_to_IN=${dateTo}&RAY_IN=&POSTAVNUMPROC_IN=&POSTAVNAMEPROC_IN=&auchan_code_in=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&ManagerNameproc_IN=&RejectFilter_IN=1&PROC_TYPE_IN=${procType}&BARCODE_IN=&dep_in=&otd_in=&reason_in=&filter_in=${filter}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => this.mapArticlesModifyReportFromService(item));
        }
      )
    );
  }

  mapArticlesModifyReportFromService(item): IWorkflowArticleModifyReportItem {
    return {
      ...emptyWorkflowArticleModifyReportItem,
      articleStatus: item['ARTICUL_STATUS'],
      articleCloseCode: item['ARTIKUL_CLOSE_CODE'],
      articleCodeNew: item['ART_CODE_NEW'],
      barcode: item['BARCODE'],
      fromCountry: item['FROM_COUNTRY'],
      itemInDateProc: item['ITEMINDATEPROC'],
      managerNameProc: item['MANAGERNAMEPROC'],
      managerNumProc: item['MANAGERNUMPROC'],
      supplierNameProc: item['POSTAVNAMEPROC'],
      supplierNumProc: item['POSTAVNUMPROC'],
      priceContract: item['PRICECONTRACT'],
      pricePerItem: item['PRICEPERITEM'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      productCode: item['PRODUCT_CODE'],
      productName: item['PRODUCT_NAME'],
      ray: item['RAY'],
      //rejColor: item['REJCOLOR'],

      rejColor: this.decodeRejColorCode(Number(item['REJCOLOR'])),
    };
  }

  getReportArticlesModifyExcel(dateFrom: string,
                              dateTo: string,
                              filter: string,
                              filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=artikuls_modif_rdf.rptdesign&ItemInDateProc_from_IN=${dateFrom}&ItemInDateProc_to_IN=${dateTo}&RAY_IN=&POSTAVNUMPROC_IN=&POSTAVNAMEPROC_IN=&BARCODE_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&ManagerNameproc_IN=&RejectFilter_IN=1&PROC_TYPE_IN=1&auchan_code_in=&ref_dep_in=&procrefGr_in=&filter_in=${filter}&__format=xls`,
      filename: filename
    };


    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  getReportArticlesReactivateExcel(dateFrom: string,
                              dateTo: string,
                              filter: string,
                              filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/proc_reports/report_reakt_table:1.0?filter_in=` + `${dateFrom},${dateTo},,,,,,,,,,,,,0,0,${filter}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  /** Отчет Гарантийные письма
   * @param dateFrom
   * @param dateTo
   * @param filter
   */
  getWarrantyLettersReport(dateFrom: string,
                          dateTo: string,
                          filter: string,
  )
    : Observable<Array<IWorkflowWarrantyLettersReportItem>> {

    return this.getWorkflowData(`ARTUCUL_PACK.GetDarantee?date_from_in=${dateFrom}&date_to_in=${dateTo}&sup_num_in=&sup_name_in=&proc_in=&all_art_in=1&art_code_in=&dep_in=&otd_in=&filter_in=${filter}` //&filter_in=${filter}
    ).pipe(
      map(
        result => {
          //return result;
          if (Array.isArray(result[0]['myData']['rowitem'])) {
            return result[0]['myData'] ? result[0]['myData']['rowitem'].map(item => this.mapWarrantyLettersReportFromService(item)) : [];
          } else {
            return result[0]['myData'] ? Array(result[0]['myData']['rowitem']).map(item => this.mapWarrantyLettersReportFromService(item)) : [];
          }
        }
      )
    );
  }

  mapWarrantyLettersReportFromService(item): IWorkflowWarrantyLettersReportItem {
    return {
      ...emptyWorkflowWarrantyLettersReportItem,
      articleCodeNew: item['ART_CODE_NEW'],
      isGuaranteeFrom: item['ISGUARANTEE_FROM'],
      isGuaranteeNotUnified: item['ISGUARANTEE_NOT_UNIFIED_D'],
      isGuaranteeTo: item['ISGUARANTEE_TO'],
      isGuaranteeUnified: item['ISGUARANTEE_UNIFIED_D'],
      supplierNameProc: item['POSTAVNAMEPROC'],
      supplierNumProc: item['POSTAVNUMPROC'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      productName: item['PRODUCT_NAME'],

    };
  }

  getReportWarrantyLettersExcel(dateFrom: string,
                               dateTo: string,
                               filter: string,
                               filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=getDarantee.rptdesign&date_from_in=${dateFrom}&date_to_in=${dateTo}&sup_num_in=&sup_name_in=&proc_in=&all_art_in=1&art_code_in=&ref_dep_in=&procrefGr_in=&filter_in=${filter}&__format=xls`,
      filename: filename
    };


    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }




  /** Отчет о сроках годности
   * @param dateFrom
   * @param dateTo
   * @param filter
   */
  getShelfLifeReport(dateFrom: string,
                     dateTo: string,
                     filter: string,
  )
    : Observable<Array<IWorkflowShelfLifeReportItem>> {

    return this.getWorkflowData(`audit_pack.GET_SHELF_LIFE?date_from_in=${dateFrom}&date_to_in=${dateTo}&suppl_num_in=&art_num_IN=&filter_in=${filter}` //&filter_in=${filter}
    ).pipe(
      map(
        result => {

          if (Array.isArray(result[0]['SHELF_LIFE_Data']['rowitem'])) {
            return result[0]['SHELF_LIFE_Data'] ? result[0]['SHELF_LIFE_Data']['rowitem'].map(item => this.mapShelfLifeReportFromService(item)) : [];
          } else {
            return result[0]['SHELF_LIFE_Data'] ? Array(result[0]['SHELF_LIFE_Data']['rowitem']).map(item => this.mapShelfLifeReportFromService(item)) : [];
          }

        }
      )
    );
  }

  mapShelfLifeReportFromService(item): IWorkflowShelfLifeReportItem {
    return {
      ...emptyWorkflowShelfLifeReportItem,
      articleCodeNew: item['ART_CODE_NEW'],
      dateInput: item['DATE_INPUT'],
      dateInputOld: item['DATE_INPUT_OLD'],
      flagShelfLife: item['FLG_SHELF_LIFE'],
      supplierNameProc: item['POSTAVNAMEPROC'],
      supplierNumProc: item['POSTAVNUMPROC'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      productName: item['PRODUCT_NAME'],
      productNameNew: item['PRODUCT_NAME_NEW'],
      productShelfLife: item['PRODUCT_SHELF_LIFE'],
      productShelfLifeOld: item['PRODUCT_SHELF_LIFE_OLD'],

    };
  }

  getReportShelfLifeExcel(dateFrom: string,
                                dateTo: string,
                                filter: string,
                                filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=getSHELF_LIFE.rptdesign&date_from_in=${dateFrom}&date_to_in=${dateTo}&sup_num_in=&art_code_in=&filter_in=${filter}&__format=xls`,
      filename: filename
    };


    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }



  /** Отчет Прайслистов
   * @param dateFrom
   * @param dateTo
   * @param filter
   */
  getPricelistsReport(dateFrom: string,
                         dateTo: string,
                         filter: string,
                      grappaCode: string = '**'
  )
    : Observable<Array<IWorkflowPricelistsReportItem>> {

    return this.getWorkflowData(`tarif_pack.get_pricelist_table?nDateProc_from_IN=${dateFrom}&nDateProc_to_IN=${dateTo}&GRAPPA_ID_IN=${grappaCode}&POSTAVNUMPROC_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&auchan_code_in=&filter_in=${filter}` //&filter_in=${filter}
    ).pipe(
      map(
        result => {
          //return result;
          //return result.map(item => this.mapArticlesCloseReportFromService(item));

           if (Array.isArray(result[0]['pricelistData']['pricelisrowitem'])) {
            return result[0]['pricelistData'] ? result[0]['pricelistData']['pricelisrowitem'].map(item => this.mapPricelistsReportFromService(item)) : [];
          } else {
            return result[0]['pricelistData'] ? Array(result[0]['pricelistData']['pricelisrowitem']).map(item => this.mapPricelistsReportFromService(item)) : [];
          }

        }
      )
    );
  }


  getReportPricelistsExcel(dateFrom: string,
                              dateTo: string,
                              filter: string,
                              grappaCode: string = '**',
                              filename: string = "''"): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=pricelist_table.rptdesign&nDateProc_from_IN=${dateFrom}&nDateProc_to_IN=${dateTo}&GRAPPA_ID_IN=${grappaCode}&POSTAVNUMPROC_IN=&PROCESS_INSTANCE_ID_IN=&MANAGERNUMPROC_IN=&auchan_code_in=&filter_in=${filter}&__format=xls`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  mapPricelistsReportFromService(item): IWorkflowPricelistsReportItem {
    return {
      ...emptyWorkflowPricelistsReportItem,
      articleCodeNew: item['CODE'],
      completeTime: item['COMPLETE_TIME'],
      currentPrice: item['CUR_PRICE'],
      dateTarif: item['DATE_TARIF'],
      grappa: item['GRAPPA'],
      managerNameProc: item['MANAGERNAMEPROC'],
      productName: item['NAME'],
      processInstanceId: item['PROCESS_INSTANCE_ID'],
      sellPrice: item['SEL_PRICE'],
      startTime: item['START_TIME'],
    };
  }


  //Карточка кодификации для закрытия
  getCloseReportCardCodification(processId: string, filename: string = "''"): Observable<IWorkflowFile> {
    //Closure_nomenclature_articles Creation_nomenclature_articles
    const header = {
      fileUrl: `/rest/services/Closure_nomenclature_articles/GetKodifRepClose:1.0?process_id_in=${processId}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  //Карточка кодификации для создания артикулов
  getCreateReportCardCodification(processId: string,
                                  filename: string = "''",
                                  partEnterStr: string,
                                  statusArticlesStr: string,
                                  codeAssortmentStr: string,
                                  isCreatedForMoscow: string): Observable<IWorkflowFile> {
    //Closure_nomenclature_articles Creation_nomenclature_articles
    const header = {
      fileUrl: `/rest/services/Creation_nomenclature_articles/getKodifReport:1.0?process_id_in=${processId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  //Карточка кодификации для реактивации артикулов
  getReactivateReportCardCodification(processId: string,
                                  filename: string = "''",
                                  partEnterStr: string,
                                  statusArticlesStr: string,
                                  codeAssortmentStr: string,
                                  isCreatedForMoscow: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/Modification_react/getKodifReportReakt:1.0?process_id_in=${processId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  //Карточка кодификации для модификации артикулов
  getModifyReportCardCodification(processId: string,
                                      filename: string = "''",
                                      partEnterStr: string,
                                      statusArticlesStr: string,
                                      codeAssortmentStr: string,
                                      isCreatedForMoscow: string): Observable<IWorkflowFile> {
    const header = {
      fileUrl: `/rest/services/Modification_react/getKodifReportModif:1.0?process_id_in=${processId}&str_rej=${partEnterStr}&str_status=${statusArticlesStr}&str_assort=${codeAssortmentStr}&moscow_in=${isCreatedForMoscow}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  //Mercuriale:информация для изменения цен
  getPricelistReportCardMercuriale(processId: string,
                                  filename: string = "''"
                                 ): Observable<IWorkflowFile> {
    const header = {
      fileUrl: `/rest/services/Price_validation_app/getPriceListReport:1.0?process_id_in=${processId}&pricelist=0`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        console.log(result);
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  //Отчет Прайслист с/без указания срока годности
  getPricelistReport(processId: string,
                     filename: string = "''",
                     isProductWithShelfLife: boolean = true
  ): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/rest/services/Price_validation_app/getPriceListReport:1.0?process_id_in=${processId}&pricelist=1&PRODUCT_SHELF_LIFE_IN=${isProductWithShelfLife?'1':'0'}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }

  getReport(reportUrl: string,
            filename: string = "''"
  ): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `${reportUrl}`, //`/rest/services/AttachmentsOp/GetDocListHTTP:1.0?ProcessID=${processId}`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  /** Отчет Загрузка цен в GICA
   * @param typeProcess
   * @param dateFromFinished
   * @param dateToFinished
   * @param dateFromLoaded
   * @param dateToLoaded
   * @param status
   * @param filter
   */
  getTariffLoadReport(typeProcess: string,
                      dateFromFinished: string,
                      dateToFinished: string,
                      dateFromLoaded: string,
                      dateToLoaded: string,
                      status: string,
                      filter: string
  )
    : Observable<Array<IWorkflowTariffLoadReportItem>> {

    return this.getWorkflowData(`tarif_pack.get_pricelist_2_gica_rdf?nDateProc_from_in=${dateFromFinished}&nDateProc_to_in=${dateToFinished}&ItemLoadProc_from_in=${dateFromLoaded}&ItemLoadProc_to_in=${dateToLoaded}&load_type_combo_in=${status}&filter_in=${filter}&mode_in=${typeProcess}`
    ).pipe(
      map(
        result => {
          return result.map(item => this.mapTariffLoadReportFromService(item));
        }
      )
    );
  }

  mapTariffLoadReportFromService(item): IWorkflowTariffLoadReportItem {
    return {
      ...emptyWorkflowTariffLoadReportItem,
      count: item['cnt'],
      dayLoaded: item['daye_loaded'],
      irAdminId: item['iradminId'],
      processId: item['process_id'],
      result: item['result'],
      supplierName: item['supplier_name'],
    };
  }

  /** Отчет Загрузка цен в GICA в Excel
   * @param typeProcess
   * @param dateFromFinished
   * @param dateToFinished
   * @param dateFromLoaded
   * @param dateToLoaded
   * @param status
   * @param filter
   * @param filename
   */
  getTariffLoadReportExcel(typeProcess: string,
                           dateFromFinished: string,
                           dateToFinished: string,
                           dateFromLoaded: string,
                           dateToLoaded: string,
                           status: string,
                           filter: string,
                           filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=get_pricelist_2_gica_main.rptdesign&nDateProc_from_in=${dateFromFinished}&nDateProc_to_in=${dateToFinished}&ItemLoadProc_from_in=${dateFromLoaded}&ItemLoadProc_to_in=${dateToLoaded}&load_type_combo_in=${status}&proc_in_IN=${filter}&sup_in_IN=&mode_in=${typeProcess}&__format=xls`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  /** Отчет Сравнение цен с GICA
   * @param typeProcess
   * @param dateFromStarted
   * @param status
   * @param showWithNoConsistency
   * @param filter
   */
  getTariffCompareReport(typeProcess: string,
                         dateFromStarted: string,
                         status: string,
                         showWithNoConsistency: string,
                         filter: string = ""
  )
    : Observable<Array<IWorkflowTariffCompareReportItem>> {

    return this.getWorkflowData(`tarif_pack.price_comparison_rdf?mode_in=${status}&date_from=${dateFromStarted}&date_prim=&error_only=${showWithNoConsistency}&proc_type=${typeProcess}`
    ).pipe(
      map(
        result => {
          return result.map(item => this.mapTariffCompareReportFromService(item));
        }
      )
    );
  }

  mapTariffCompareReportFromService(item): IWorkflowTariffCompareReportItem {
    return {
      ...emptyWorkflowArticleCreationReportItem,
      completeTime: item['complete_time'],
      currentPrice: item['currentprice'],
      currentPriceDate: item['currentpricedate'],
      dateLoaded: item['date_loaded'],
      grappe: item['grappe'],
      irAdminId: item['iradmin'],
      item: item['item'],
      processId: item['process_id'],
      res: item['res'],
      supplierName: item['supname'],
      tariff: item['tariff'],
    };
  }

  /** Отчет Сравнение цен с GICA в Excel
   * @param typeProcess
   * @param dateFromStarted
   * @param status
   * @param showWithNoConsistency
   * @param filter
   * @param filename
   */
  getTariffCompareReportExcel(typeProcess: string,
                              dateFromStarted: string,
                              status: string,
                              showWithNoConsistency: string,
                              filter: string = "",
                              filename: string): Observable<IWorkflowFile> {

    const header = {
      fileUrl: `/birt/frameset?__report=Price_comparison.rptdesign&mode_in=${status}&date_from=${dateFromStarted}&date_prim=&error_only_chbox=${showWithNoConsistency}&proc_type=${typeProcess}&__format=xls`,
      filename: filename
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/getreport`, header).pipe(
      map(result => {
        if (result['Error'] === 0 && result['Report'].length > 0) {
          const file: IWorkflowFile = this.mapReporExcelFromService(result);
          return file;
        } else {
          return {...emptyWorkflowFile};
        }
      })
    );
  }


  ////////////////////////////////////////////////////////
  ///////////////////// USERS ///////////////////////////
  ///////////////////////////////////////////////////////

  getSites(user: string)
    : Observable<Array<any>> {

    return this.getWorkflowData(`users_pack.Get_sites?user_in=${user}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => ({code: item['SITENAME'], name: item['SITENAME']}));
        }
      )
    );
  }

  getUsersForImport(domain: string,
                      filter: string = ''
  )
    : Observable<Array<IWorkflowUserItem>> {

    return this.getWorkflowData(`users_pack.Get_AD_USERS_2_IMPORT2?domain_in=${domain}&filter_in=${filter}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => this.mapUserFromService(item));
        }
      )
    );
  }

  getUsers(domain: string,
           filter: string = '',
           group: string,
           department: string
  )
    : Observable<Array<IWorkflowUserItem>> {

    return this.getWorkflowData(`users_pack.GetUsersHttp?domain_in=${domain}&GroupIn=${group}&FilterStr=${filter}&DepartmentIn=${department}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => this.mapUserFromService(item));
        }
      )
    );
  }

  saveUserLocalization(user: IWorkflowUserItem): Observable<IServiceResponse> {
    const header = {
      operationURL: `users_pack.set_localization_of_buyer?localization_of_buyer_in=${user.localization}&userLogin=${user.login}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  checkUser(user: IWorkflowUserItem, nomaCodes: string = '', managerNomaCodes: string = ''): Observable<any> {

    const header = {
      operationURL: `users_pack.get_check_buyer_all_fam?NOMFAM_CODE_IN=${nomaCodes}&ecommerce_in=${user.ecommerce?'1':'0'}&manager_ray_in=${managerNomaCodes}&USER_RU_IN=${user.login}`
    };

    return this.getWorkflowData(header.operationURL).pipe(
      mergeMap(result => {
          console.log(result);
          let errorMessage = '';

          if (result[0]['out_error'] === '1') errorMessage = result[0]['out_mess'];

          return of({errorMessage: errorMessage});

        }
      )
    );

  }


  saveUserMainInfo(user: IWorkflowUserItem, domain: string): Observable<IServiceResponse> {

    let groups = user.groupsMember.length > 0 ? user.groupsMember.map(item => item.code).toString() + ',' : '';
    groups += user.groupsChief.length > 0 ? user.groupsChief.map(item => item.code).toString() + ',' : '';
    console.log(groups);

    const header = {
      operationURL: `/rest/services/TarifUserManagement/UserUpdate:1.0?IsChief=${user.isManager}&domain=${domain}&emailAddress=${user.email}&familyName=${user.lastName}&givenName=${user.firstName}&managernum=${user.managerNum}&memberOfGroupId=${groups}&mode_in=${'3'}&password=${''}&userLogin=${user.login}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/lcproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  //ToDo managerName проверить какое поле берется
  saveUserManager(user: IWorkflowUserItem): Observable<IServiceResponse> {
    const header = {
      operationURL: `users_pack.UserChiefUpdate?manager_in=${user.manager}&userLogin=${user.login}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  ////ToDo добавить группы в Юзера
  saveUserIsManager(user: IWorkflowUserItem, authentificateUser: string): Observable<IServiceResponse> {

    const groups = user.groupsChief.length > 0 ? user.groupsChief.map(item => item.code).toString() + ',' : '';

    const header = {
      operationURL: `users_pack.UpdateIsManagerHTTP?domain_in=${user.domain}&login_in=${user.login}&update_user=${authentificateUser}&groups_in=${groups}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }


  getUserGroups(domain: string): Observable<any> {
    return this.getWorkflowData(`users_pack.GetAllGroups?domain_in=${domain}`
    ).pipe(
      map(
        result => {
          return result.map(item => ({code: item['COMMONNAME'], name: item['FULLNAME']}));
        }
      )
    );
  }

  getUserDepartments(login: string, domain: string): Observable<Array<IWorkflowUserDepartmentItem>> {
    return this.getWorkflowData(`users_pack.GetUserDepsHTTP?login_in=${login}&domain_in=${domain}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => this.mapUserDepartmentFromService(item));
        }
      )
    );
  }

  getUserLocalizations(login: string): Observable<Array<any>> {
    return this.getWorkflowData(`users_pack.get_localization_of_buyer?userLogin=${login}`
    ).pipe(
      map(
        result => {
          //return result;
          return result.map(item => ({code: item['ATTR_VALUE'], name: item['ATTR_VALUE']}));
        }
      )
    );
  }

  getUserNomenclature(login: string): Observable<Array<INomenclatureTreeItem>> {
    return this.getWorkflowData(`users_pack.GetBuyerFam3?RU_IN=${login}`
    ).pipe(
      map(
        result => {
          return result.map(item => this.mapNomenclature2TreeItemFromService(item));
        }
      )
    );
  }

  getUserManagerNomenclature(code: string = '0', login: string, ecommerce: string = '0'): Observable<Array<INomenclatureTreeItem>> {
    return this.getWorkflowData(`users_pack.get_manager_ray?CODE_IN=${code}&USERNAME_IN=${login}&ecommerce_in=${ecommerce}`
    ).pipe(
      map(
        result => {
          return result.map(item => this.mapNomenclatureTreeItemFromService(item));
        }
      )
    );
  }

  saveUserManagerNomenclature(user: IWorkflowUserItem, authentificateUser: string): Observable<IServiceResponse> {

    const nomaCodes = user.nomenclature.map(item => item.code).toString();

    const header = {
      operationURL: `users_pack.set_manager_ray?ecommerce_in=${user.ecommerce?'1':'0'}&update_user=${authentificateUser}&CODES_ARR_IN=${nomaCodes}&USERNAME_IN=${user.login}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  saveUserNomenclature(user: IWorkflowUserItem): Observable<IServiceResponse> {

    const nomaCodes = user.nomenclature.map(item => item.code).toString();

    const header = {
      operationURL: `oper_buyer_fam_rdf?USER_RU_IN=${user.login}&NOMFAM_CODE_IN=${nomaCodes}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/apexproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }

  getUsersFilter(filter: string): Observable<Array<any>> {
    return this.getWorkflowData(`get_users?FilterStr_in=${filter}`
    ).pipe(
      map(
        result => {
          return result.map(t => ({code: t['PRINCIPALOID'], name: `${t['COMMONNAME']}`}));
        }
      )
    );
  }

  getUsersFilter2(filter: string): Observable<Array<any>> {
    return this.getWorkflowData(`get_dep_users_proc?DOMAINNAME_IN=921_Sokolniki&GROUPNAME_IN=---&FilterStr_in=${filter}`
    ).pipe(
      map(
        result => {
          return result.map(t => ({code: t['PRINCIPALOID'], name: `${t['COMMONNAME']}`, description: t['UIDSTRING']}));
        }
      )
    );
  }


  getUserSubstitution(userId: string): Observable<Array<IUserSubstitutionItem>> {
    return this.getWorkflowData(`users_pack.get_ooo_workflow_user?refprincipalid_in=${userId}`
    ).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          return result.filter(item => Object.keys(item).length !== 0).map(item => this.mapUserSubstitutionFromService(item));
        }
      )
    );
  }

  getUserSubstitutionPeriod(userId: string): Observable<Array<IPeriodListItem>> {
    return this.getWorkflowData(`users_pack.get_ooo_period?refprincipalid_in=${userId}`
    ).pipe(
      map(
        result => {
          console.log(result);
          //return result;
          //if (Object.keys(result[0]).length === 0) return of([]);
          return result.filter(item => Object.keys(item).length !== 0).map(item => this.mapUserSubstitutionPeriodFromService(item));
        }
      )
    );
  }

  setUserSubstitution(user: IWorkflowUserItem): Observable<Array<any>> {


    return this.getWorkflowData(`users_pack.set_ooo_workflow_user?${this.prepareUserSubstitutionForService(user)}`
    ).pipe(
      map(
        result => {
          console.log(result);
          return result;
          //return result.map(item => this.mapUserSubstitutionPeriodFromService(item));
        }
      )
    );
  }

  prepareUserSubstitutionForService(user: IWorkflowUserItem):string {
    let paramStr = '';

    paramStr += `refprincipalid_in=${user.principalOid}&`;
    paramStr += `email_task_assigned_in=${user.substitution.emailTaskAssigned}&`;
    paramStr += `task_assigned_form_in=${user.substitution.taskAssignedForm}&`;
    paramStr += `email_task_reminder_in=${user.substitution.emailTaskReminder}&`;
    paramStr += `task_reminder_form_in=${user.substitution.taskReminderForm}&`;
    paramStr += `email_task_deadline_in=${user.substitution.emailTaskDeadline}&`;
    paramStr += `is_out_of_office_in=${user.substitution.isOutOfOffice}&`;
    paramStr += `is_not_default_designate_in=${user.substitution.isNotDefaultDesignate}&`;
    paramStr += `default_queue_id_in=${user.substitution.defaultQueueId}&`;
    paramStr += `out_of_office_user_id_in=${user.substitution.outOfOfficeUserId}&`;
    paramStr += `start_date_in=${''}&`;
    paramStr += `end_date_in=${''}`;


    return paramStr;
  }

  setUserSubstitutionPeriod(userId: string, id: string, dateStart: string, dateEnd: string, operation: string): Observable<Array<any>> { //IWorkflowUserDepartmentItem>> {
    /*
    refprincipalid_in
    id_in
    start_date_in
    end_date_in
    operation_in in number-- 0 add,1-delete,2-update
     */
    return this.getWorkflowData(`users_pack.set_ooo_period?refprincipalid_in=${userId}&id_in=${id}&start_date_in=${dateStart}&end_date_in=${dateEnd}&operation_in=${operation}`
    ).pipe(
      map(
        result => {
          console.log(result);
          return result;
          //return result.map(item => this.mapUserSubstitutionPeriodFromService(item));
        }
      )
    );
  }

  mapUserSubstitutionFromService(item): IUserSubstitutionItem {
    return {
      ...emptyUserSubstitutionItem,
      defaultQueueId: item['default_queue_id'],
      emailTaskAssigned: item['email_task_assigned'],
      emailTaskDeadline: item['email_task_deadline'],
      emailTaskReminder: item['email_task_reminder'],
      isNotDefaultDesignate: item['is_not_default_designate'],
      isOutOfOffice: item['is_out_of_office'],
      outOfOfficeUserId: item['out_of_office_user_id'],
      principalOid: item['refprincipalid'],
      taskAssignedForm: item['task_assigned_form'],
      taskReminderForm: item['task_reminder_form'],
    };
  }


  mapUserSubstitutionPeriodFromService(item): IPeriodListItem {
    return {
      ...emptyPeriodListItem,
      id: item['id'],
      type: 'update',
      isSaved: true,
      dateStart: moment(item['start_date'], 'DD.MM.YYYY'),
      dateEnd: moment(item['end_date'], 'DD.MM.YYYY'),
    };
  }



  mapUserFromService(item): IWorkflowUserItem {
    return {
      ...emptyWorkflowUserItem,
      binom: item['BINOM'],
      commonName: item['COMMONNAME'],
      departament: item['DEPARTAMENT'],
      email: item['EMAIL'],
      lastName: item['FAMILYNAME'],
      firstName: item['GIVENNAME'],
      groupName: item['GROUPNAME'],
      initials: item['INITIALS'],
      managerNum: item['MANAGERNUM'],
      principalOid: item['PRINCIPALOID'],
      segments: item['SEGMENTS'],
      login: item['UIDSTRING'],

      isManager: item['ISMANAGER'],
      managerName: item['MANAGERNAME'],
      manager: item['manager'],
    };
  }

  mapUserDepartmentFromService(item): IWorkflowUserDepartmentItem {
    return {
      ...emptyWorkflowUserDepartmentItem,
      canonicalName: item['CANONICALNAME'],
      commonName: item['COMMONNAME'],
      domainCommonName: item['DOMAIN_COMMONNAME'],
      fullName: item['FULLNAME'],
      isManager: item['is_manager'] === 1,
      isMember: item['is_member'] === 1,

    };
  }

  mapNomenclatureTreeItemFromService(item): INomenclatureTreeItem {
    return {
      ...emptyNomenclatureTreeItem,
      code: item['CODE'],
      name: item['current_name'],
      parentCode: item['PARENT_CODE'],
      selected: item['is_member'] === 1,
    };
  }

  mapNomenclature2TreeItemFromService(item): INomenclatureTreeItem {
    return {
      ...emptyNomenclatureTreeItem,
      code: item['CODE'],
      name: item['NAME'],
      parentCode: item['PARENT_CODE'],
      selected: item['cnt'] === "1",
    };
  }




  importUsersFromAD(site: string, usersStr: string): Observable<IServiceResponse> {
    //domain - site name, в workflow же только один домен 921, пользователи импортируются в него
    const header = {
      operationURL: `/rest/services/TarifUserManagement/AD_USERS_SYNC:1.0?domain_in=${site}&users_in=${usersStr}`
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/lcproxy`, header).pipe(
      map(result => {
          console.log(result);
          return result;
        }
      )
    );
  }




  /** Назначения для задачи
   * @param taskId
   */
  getTaskAssignments(taskId: string): Observable<Array<IWorkflowTaskAssignmentItem>> {

    return this.getWorkflowData(`audit_pack.get_task_assigments?task_id_in=${taskId}`
    ).pipe(
      map(result => {
          return result.map(item => this.mapTaskAssignmentsFromService(item));
        }
      )
    );
  }

  mapTaskAssignmentsFromService(item): IWorkflowTaskAssignmentItem {
    return {
      ...emptyWorkflowTaskAssignmentItem,
      assignmentCreateTime: item['a_create_time'] ? moment(item['a_create_time'], 'DD.MM.YYYY').toDate() : null,
      assignmentUpdateTime: item['a_update_time'] ? moment(item['a_update_time'], 'DD.MM.YYYY').toDate() : null,
      assignmentType: item['assign_type'],
      assignmentUser: item['q_title'],

    };
  }


  mapReporExcelFromService(item: object): IWorkflowFile {
    const file: IWorkflowFile = {
      ...emptyWorkflowFile,
      fileId: '',
      filename: decodeURIComponent(item['FileName']),
      content: item['Report']
    };
    return file;
  }


  mapFileInfoFromService(item: object): IWorkflowFileInfo {
    const fileInfo: IWorkflowFileInfo = {
      ...emptyWorkflowFileInfo,
      id: item['id'],
      filename: item['filename'],
      description: item['description'],
      permissions: item['permissions'],
      idTask: item['taskId'],
      userId: item['CreateUserId'],
      dateCreate: item['CreateTime'] ? moment(item['CreateTime'], 'YYYY-MM-DD HH:mm: ss.SSS').toDate() : null,
      dateUpdate: item['UpdateTime'] ? moment(item['UpdateTime'], 'YYYY-MM-DD HH:mm: ss.SSS').toDate() : null,
      filesize: item['filesize'] ? item['filesize'] : ""
    };
    return fileInfo;
  }

  mapFileFromService(item: object): IWorkflowFile {
    const file: IWorkflowFile = {
      ...emptyWorkflowFile,
      fileId: '',
      filename: item['filename'],
      content: item['content']
    };
    return file;
  }

  mapGroupFromService(item: object): IWorkflowGroup {
    const group: IWorkflowGroup = {
      ...emptyWorkflowGroup,
      id: item['ID'],
      code: item['CODE'],
      name: item['NAME'],
      taskCount: item['Note'] ? parseInt(item['Note'], 10) : 0
    };
    return group;
  }

  //скачать файл base64
  downloadFile(file: IWorkflowFile) {

    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    };


    const blob = b64toBlob(file.content);

    const blobUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    const fileName = file.filename;
    downloadLink.href = blobUrl;
    downloadLink.download = decodeURIComponent(fileName.replace(/%/g,''));
    downloadLink.click();

    console.log(downloadLink);

    URL.revokeObjectURL(blobUrl);

  }


  checkModifTariffProcess(processId: string, otdelName: string, departmentName: string, state: string, route: string, lang: string): Observable<any> {

    return this.getWorkflowData(`GetCheckProcData_all?PROCESSID_IN=${processId}&otdNameIn=${otdelName}&depNameIn=${departmentName}&state_in=${state}&route_in=${route}&lang_in=${lang}`).pipe(
      mergeMap(
        result => {
          console.log('tariff_check');

          let errorMessage = '';

          if (result[0]['otdNameInCnt'] !== '1') errorMessage += result[0]['otdNameMess'];
          if (result[0]['depNameCnt'] !== '1') errorMessage += result[0]['depNameMesss'];
          if (result[0]['errorflg'] === '1') errorMessage += result[0]['errorMess'];

          if (errorMessage) {
            return of({errorMessage: errorMessage});
          } else {
            return of({errorMessage: ''});
          }
        }
      )
    );
  }

  checkAllDataProcess(processId: string, otdelName: string, departmentName: string, state: string, route: string, lang: string): Observable<any> {

    return this.getWorkflowData(`Get_all_proc_CheckData?PROCESSID_IN=${processId}&otdNameIn=${otdelName}&depNameIn=${departmentName}&state_in=${state}&route_in=${route}&lang_in=${lang}`).pipe(
      mergeMap(
        result => {
          console.log('all_check');

          let errorMessage = '';

          if (result[0]['otdNameInCnt'] !== '1') errorMessage += result[0]['otdNameMess'];
          if (result[0]['depNameCnt'] !== '1') errorMessage += result[0]['depNameMesss'];
          if (result[0]['errorflg'] === '1') errorMessage += result[0]['errorMess'];

          if (errorMessage) {
            return of({errorMessage: `${errorMessage}`}); //Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили требуемую информацию о следующих артикулах:
          } else {
            return of({errorMessage: ''});
          }
        }
      )
    );
  }


  /**
   * Проверка процесса перед отправкой
   * @param processId
   */
  checkReactivateProcess(processId: string, otdelName: string, departmentName: string, state: string, route: string, lang: string): Observable<any> {

    return this.getWorkflowData(`MODIFY_ART.GetArtikulCheckDataModif?PROCESSID_IN=${processId}&otdNameIn=${otdelName}&depNameIn=${departmentName}&state_in=${state}&route_in=${route}&lang_in=${lang}`).pipe(
      mergeMap(
        result => {
          console.log('modify_check');

          let errorMessage = '';

          if (result[0]['otdNameInCnt'] !== '1') errorMessage += result[0]['otdNameMess'];
          if (result[0]['depNameCnt'] !== '1') errorMessage += result[0]['depNameMesss'];
          if (result[0]['errorflg'] === '1') errorMessage += result[0]['errorMess'];

          if (errorMessage) {
            return of({errorMessage: errorMessage});
          } else {
            return this.checkAllDataProcess(processId, otdelName, departmentName, state, route, lang);
          }
        }
      )
    );
  }

  checkPricelistProcess(processId: string = '', supplierCode: string, dateIn: string,
                        otdelName: string, departmentName: string, state: string = '', route: string = '', lang: string = ''): Observable<any> {

    return this.getWorkflowData(`tarif_pack.GetPriceListCheck?PROCESSID_IN=${processId}&t_POSTAVNUMPROC=${supplierCode}&t_dateIn=${dateIn}&otdNameIn=${otdelName}&depNameIn=${departmentName}&state_in=${state}&route_in=${route}&lang_in=${lang}`).pipe(
      mergeMap(
        result => {
          console.log('tariff_check');

          let errorMessage = '';

          if (result[0]['otdNameInCnt'] !== '1') errorMessage += result[0]['otdNameMess'];
          if (result[0]['depNameCnt'] !== '1') errorMessage += result[0]['depNameMesss'];
          if (result[0]['errorflg'] === '1') errorMessage += result[0]['errorMess'];

          if (errorMessage) {
            return of({errorMessage: errorMessage});
          } else {
            return of({errorMessage: ''});
          }
        }
      )
    );
  }

  getSupplierProcesses(processType: string,
                       startDateFrom: string,
                       startDateTo: string,
                       filter: string,
                       status: string,
                       limit: number = 100,
                       offset: number = 0
  ): Observable<Array<IWorkflowProcess>> {

    /*
       map(
         result => {
           return result.map(item => mapAuchanAuditProcessesFromService(item));
         }
       )
   */

    const param = {
      search_filter: filter,
      proctype_in: processType,
      startdatefrom: startDateFrom,
      startdateto: startDateTo,
      status: 0,
      offset: offset,
      limit: limit
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/sprocesses`, param).pipe(
      map(result => {
        console.log(result);
        const processes: Array<IWorkflowProcess> = result.report.filter(item => Object.keys(item).length !== 0).map(t => mapAuchanAuditProcessesFromService(t));
        return processes;
      })
    );

  }

  getSupplierProcess(processId: string): Observable<any> { //IWorkflowTask> {
    const param = {};

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/sprocesses/${processId}`, param).pipe(
      map(result => {
        console.log(result.report[0]);
        return result.report[0];
        //const task: IWorkflowTask =  mapAuchanTaskFromService(result.report[0]);
        //return task;
      })
    );
  }


  getSupplierProcessFiles(processId: string): Observable<any> {
    const param = {};

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/sprocesses/${processId}/files`, param).pipe(
      map(result => {
        console.log(result);
        const fileInfos: Array<IWorkflowFileInfo> = result.report.map(item => this.mapFileInfoFromService(item));
        return fileInfos;
      })
    );
  }

  getSupplierArticles(supplierId: string
  ): Observable<Array<any>> { //IWorkflowProcess>> {

    const param = {
      suplId: supplierId
    };

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/articles`, param).pipe(
      map(result => {
        console.log(result);
        return result.report;
        //const processes: Array<any> = result.report.filter(item => Object.keys(item).length !== 0).map(t => mapAuchanAuditProcessesFromService(t));
        //return processes;
      })
    );

  }

  getAssortment(supplierId: string
  ): Observable<Array<IWorkflowArticleStrItem>> { //IWorkflowProcess>> {

    return this.getWorkflowData(`ARTUCUL_PACK.get_supplier_artikuls?sup_code_in=${supplierId}&filter=`
    ).pipe(
      map(result => {
          //return result;
          return result.map(item => this.mapArticleStrItemAssortmentFromService(item));
        }
      )
    );
  }

  mapArticleStrItemAssortmentFromService(item): IWorkflowArticleStrItem {
    return {
      ...emptyWorkflowArticleStrItem,
      artCodeNew: item['art_code'],
      productName: item['artikul_name'],
      barcode: item['barcode'],
      priceWithoutNds: item['cur_price'],
      discountAccount: item['cur_disc'],
      ndsRate: item['vat'],

      //region: item['grappa'],

      priceInfo: {
        ...emptyWorkflowPricelistArticle,
        code: item['art_code'],
        name: item['artikul_name'],
        currentPrice: item['cur_price'],
        currentDiscount: item['cur_disc'],
        currentTotalPrice: item['cur_total'],

        //kuTotalPrice: item['cur_total'],
        ndsRate: item['vat'],
      }

    };
  }




  //Проверка задачи при сохранении и отправке *Сообщения, выдаваемые по результатам проверки формы при отправке*
  checkTask(task: IWorkflowTask, pricesChecked: boolean = false, pricesGicaExported: boolean = false, activeTariffFileChanged: boolean = false, newTariffFileLoaded: boolean = false, route: IWorkflowAction = {...emptyWorkflowAction}, articleExistsRedStatus: boolean = false, allArticlesClosedStatus: boolean = true): string {

    let messageText = "";

    console.log(route);

    //Выполнить проверку на обязательность полей
    switch (task.description) {

      case "review": {


        if ((route.code === 'Заявка отклонена')) {
          if (!task.taskVariables['tarifmodel']['ProcessCard']['COZ_comment_supplyer'])
          {
            messageText += "* Необходимо заполнить примечание для поставщика! \n";
          }
          /*
        } else if ((route.code === 'Заявка принята') && !task.taskVariables['tarifmodel']['ProcessCard']['DataPrimen'])  {
          messageText += "* Необходимо заполнить примечание для поставщика! \n";
          */

        } else {

          if (!(task.taskVariables['tarifmodel']['ProcessCard']['Inwork'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['CodifPriceInDate'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['ContractCondish'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['DataPrimen'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['department'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['OtdelCOZ'] &&
            task.taskVariables['tarifmodel']['ProcessCard']['Zakupchik'])) {

            messageText += "* Не заполнены необходимые поля \n";
          }

          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Аннулировать тариф' && !task.taskVariables['tarifmodel']['ProcessCard']['COZ_comment_supplyer']) {

            messageText += "* Необходимо заполнить примечание для поставщика! \n";
          }

          if (task.taskVariables['tarifmodel']['ProcessCard']['UpDown'] === 'на понижение' && !pricesGicaExported) {
            messageText += "* Не выполнена загрузка цен в Gica \n";
          }

          if (!task.taskVariables['tarifmodel']['ProcessCard']['UpDown']) {
            messageText += "* Необходимо выбрать Повышение/Понижение \n";
          }

          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultVremPovishenie'] && !task.taskVariables['tarifmodel']['ProcessCard']['UpDatePo']) {
            messageText += "* Не указана дата временного повышения \n";
          }

          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultVremPonijenie'] && !task.taskVariables['tarifmodel']['ProcessCard']['DownDatePo']) {
            messageText += "* Не указана дата временного понижения \n";
          }

        }

      }
        break;

      case "Buyer": {

        if ((route.code === 'Отправить в архив') && !task.taskVariables['tarifmodel']['ProcessCard']['COZ_comment_supplyer']) {
          messageText += "* Необходимо заполнить примечание для поставщика! \n";

        } else {

          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] !== 'Принять с изменениями' && activeTariffFileChanged) {
            //Вам нужно выбрать 'Принять с изменениями', т.к. был изменен активный файл с тарифами.";
            messageText += "* Вам нужно выбрать 'Принять с изменениями', т.к. был изменен активный файл с тарифами. \n";
          } else if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] !== 'Принять с изменениями' && newTariffFileLoaded) {
            messageText += "* Вложен новый файл тарифов, необхоидмо принять процесс с изменениями. \n";
          }

          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Аннулировать тариф' && !task.taskVariables['tarifmodel']['ProcessCard']['COZ_comment_supplyer']) {

            messageText += "* Необходимо заполнить примечание для поставщика! \n";
          }

          /*
          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Принять с изменениями' && !newTariffFileLoaded) {

            messageText += "* Т.к. выбрано 'Принять с изменениями',необходимо прикрепить новый файл с тарифами на вкладку 'Тарифы'. \n";
          }
          */


          if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Принять с изменениями' //(route.code === 'Выполнено') &&
            && (activeTariffFileChanged) && !task.taskVariables['tarifmodel']['ProcessCard']['RezultCorrecciay']) {

            messageText += "* Т.к. изменен активный файл тарифов, то необходимо проставить признак Коррекция. \n";
            /*Если Активность изменена  одного на другой, то при отправке процесса руководителю сектора проверять,
            что выбран радиобатон Коррекция */

          }

          if (!task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor']) {

            messageText += "* Необходимо выбрать одно из решений! \n";
          }

          if ((task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Принять с изменениями') && !(task.taskVariables['tarifmodel']['ProcessCard']['RezultCorrecciay'] || task.taskVariables['tarifmodel']['ProcessCard']['RezultPerenosDatePrim'] || task.taskVariables['tarifmodel']['ProcessCard']['RezultOther'])) {
            messageText += "* Необходимо выбрать один из вариантов изменения! \n";
          }

        }

      }
        break;
      case "Buyer Chief": {

        if ((route.code === 'Не согласен с заключением закупщика') && !task.taskVariables['tarifmodel']['ProcessCard']['COZChefComment']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;

      case "COZDir": {

        if ((route.code === 'Не согласен с заключением закупщика') && !task.taskVariables['tarifmodel']['ProcessCard']['DirComment']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }
      }

        break;
      case "delay": {

      }
        break;
      case "check": {

        /*

        if (task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === 'Аннулировать тариф' && !task.taskVariables['tarifmodel']['ProcessCard']['COZ_comment_supplyer']) {

          messageText += "* Необходимо заполнить примечание для поставщика! \n";
        }
        */

        if ((route.code === 'Соответствие цен в каталоге проверено') && !pricesGicaExported && !(task.taskVariables['tarifmodel']['ProcessCard']['RezultatPeregovor'] === "Аннулировать тариф")) {
          messageText += "* Не выполнена загрузка цен в Gica \n";
        }

        if ((route.code === 'Вернуть закупщику') && !task.taskVariables['tarifmodel']['ProcessCard']['CodifPrimech']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;

      //Процессы с артикулами
      case "buyer": {

        if ((route.code === 'Отказано' || route.code === 'Аннулировать заявку' ||  route.code === 'Отправить  администратору') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['BuyerPrimech']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;
      case "dir": {

        if ((route.code === 'Отказано') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['dir_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;
      case "admin":
      case "proc_admin": {

        if ((route.code === 'Отказано') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['admin_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;
      /*
      case "proc_admin": {

        if ((route.code === 'Отказано') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['admin_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;
      */
      case "chief": {

        if ((route.code === 'Отказано') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['chief_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;

      case "manager": {

        if ((route.code === 'Отказано') && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['managercat_input_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;
      case "kodif_input":
      case "kodif_check": {

        if ((route.code === 'Отправить закупщику') && !articleExistsRedStatus) {
          messageText += "* Отсутствуют артикулы с красным статусом \n";
        }

        if ((route.code === 'Отправить закупщику') && (task.description === "kodif_input") && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['kodif_input_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }
        if ((route.code === 'Отправить закупщику') && (task.description === "kodif_check") && !task.taskVariables['itemcreationmodel']['ItemsCreateRow']['kodif_check_desition']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

        if ((route.code === 'Все артикулы закрыты') && !allArticlesClosedStatus) {
          messageText += "* Не все артикулы закрыты \n";
        }

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;

      case "expert_ku1":
      case "expert_ku2":
      case "buyer1": {

        if ((route.code === 'Аннулировать' || route.code === 'Цены не подтверждены') && !task.taskVariables['pricevalidmodel']['PriceValidRow']['comments']) {
          messageText += "* Для дальнейшего прохождения процесса необходимо, чтобы Вы заполнили примечание \n";
        }

      }
        break;

      default:
        messageText = ""; //Ошибка состояния процесса
        break;
    }

    return messageText;
  }


  //Проверка задачи при отправке
  checkTaskLookAnalytics(task: IWorkflowTask, route: IWorkflowAction = {...emptyWorkflowAction}, lookAnalytics: boolean = false): boolean {

    let messageText = "";

    switch (task.description) {
      case "buyer": {
        if (( route.code === 'Отправить руководителю отдела' || route.code === 'Отправить  администратору') && !lookAnalytics) {
          //messageText += "* Для дальнейшего прохождения заявки, необходимо ознакомиться с аналитикой \n";
          return false;
        }
      }
        break;
    }

    return true;
  }

  mapFormFromService(item: object):IWorkflowForm{
    const form: IWorkflowForm = {
        ...emptyWorkflowForm,

        id: item['id'],
        title: item['profile'] ? item['profile']['title'] : '',
        tooltip: item['profile'] ? item['profile']['tooltip'] : '',
        formCode: item['profile'] ? item['profile']['form_code'] : '',
        icon: item['profile'] ? item['profile']['icon'] : '',
        processDefinitionStatusCode: item['status_code'],
        profile: item['profile'],
        name: item['name'],
        description: item['description'],
        orderNo: item['order_no']
      };
    return form;
  }
  mapActionFromService(item: object):IWorkflowAction{
    const action: IWorkflowAction = {
      ...emptyWorkflowAction,
      id: item['id'],
      code: item['profile']?item['profile']['code']:'',
      nextId: item['profile']?item['profile']['next_id']:'',
      title: item['profile']?item['profile']['title']:'',
      disabled:item['profile']?item['profile']['disabled']:false,
      titleTranslation: {...emptyTranslatedName},
      actionTypeCode: item['action_type_code'],
      typeCode: item['profile']?item['profile']['type']:'',
      buttonType: item['profile']?item['profile']['button_type']:'',
      processDefinitionStatusCode: item['status_code'],
      profile: item['profile'],
      name: item['name'],
      description: item['description'],
      businessRuleCode: item['br_code']
    };
    return action;
  }
  mapStageFromService(item: object): IWorkflowProcessStage {
    const stage: IWorkflowProcessStage = {
      ...emptyWorkflowProcessStage,
      id: item['id'],
      name: item['name'],
      description: item['description'],

      processType: null,

      statusCode: item['status_code'],

      userIdCreated: item['user_id_created'],
      userNameCreated: '',
      userIdUpdated: item['user_id_updated'],
      userNameUpdated: '',

      dateCreate: moment(item['date_create'], 'YYYYMMDD').toDate(),
      dateUpdate: moment(item['date_update'], 'YYYYMMDD').toDate(),

      forms: [],
      actions: [],

      profile: item['profile']
    };
    return stage;
  }

  decodeButtonType(type: string):EButtonType {
    switch (type) {
      case 'ButtonOkAlt': return EButtonType.ButtonOkAlt;
      case 'ButtonCancel': return EButtonType.ButtonCancel;
      case 'ButtonOk': return EButtonType.ButtonOk;

      default: return EButtonType.ButtonOkAlt;


    }
  }

}
